export default {
  "nav_signin": "Prijava",
  "nav_account": "Račun",
  "nav_signout": "Odjava",
  "hero_title": "Pametna digitalna rješenja",
  "hero_title_line1": "Infinity Business — Pametna",
  "hero_title_line2": "Digitalna rješenja",
  "hero_subtitle": "Upoznajte Ristu, vašeg digitalnog partnera",
  "hero_cta": "Razgovarajte s Ristom",
  "hero_cta2": "Pogledaj usluge",
  "b2b_title": "Poslovna rješenja (B2B)",
  "p2p_title": "Osobna rješenja (P2P)",
  "b2b_desc": "Web, mobilne, softverske usluge, hosting, dizajn i oglašavanje",
  "p2p_desc": "Kripto edukacija, alati za ulaganje, organizacija, prijevod, brendiranje, domene",
  "services_title": "Naše usluge",
  "services_subtitle": "Od poslovnih web rješenja do osobnih alata za ulaganje. RisTA vas vodi.",
  "cta_title": "Spremni za nešto nevjerojatno?",
  "cta_subtitle": "Razgovarajte s Ristom za personaliziranu ponudu u minutama.",
  "about": "O nama",
  "contact": "Kontakt",
  "privacy": "Politika privatnosti",
  "blog": "Blog",
  "donate": "Donirajte",
  "booking": "Rezervirajte termin",
  "login_title": "Dobrodošli natrag",
  "register_title": "Kreirajte račun",
  "login_subtitle": "Prijavite se na svoj Infinity Business račun",
  "register_subtitle": "Pridružite se Infinity Businessu danas",
  "auth0_btn": "Nastavite s Auth0",
  "or_email": "ili nastavite s e-mailom",
  "email": "E-mail adresa",
  "password": "Lozinka",
  "full_name": "Puno ime",
  "signin_btn": "Prijava",
  "register_btn": "Kreiraj račun",
  "no_account": "Nemate račun?",
  "have_account": "Već imate račun?",
  "create_one": "Kreirajte",
  "sign_in": "Prijavite se",
  "pricing_title": "Odaberite plan",
  "pricing_subtitle": "Svi planovi uključuju pristup Risti.",
  "pay_stripe": "Plati putem Stripe",
  "pay_mypos": "Plati putem myPOS",
  "pay_crypto": "Plati kriptom",
  "free_plan": "Trenutni besplatni plan",
  "most_popular": "Najpopularniji",
  "dashboard_title": "Moj račun",
  "profile": "Profil",
  "security": "Sigurnost (2FA)",
  "subscription": "Pretplata",
  "upgrade": "Nadogradnja",
  "change_plan": "Promijeni plan",
  "twofa_title": "Dvofaktorska autentifikacija",
  "setup_2fa": "Postavi 2FA",
  "disable_2fa": "Onemogući 2FA",
  "payment_success": "Plaćanje uspješno!",
  "payment_cancel": "Plaćanje otkazano",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Sva prava pridržana.",
  "about_title": "O Infinity Business",
  "contact_title": "Kontaktirajte nas",
  "privacy_title": "Politika privatnosti",
  "send_message": "Pošalji poruku",
  "trade_title": "Trgujemo za vas",
  "trade_desc": "Profesionalne usluge kripto trgovanja. Razgovarajte s nama.",
  "back_home": "Natrag na početnu",
  "loading": "Učitavanje...",
  "save": "Spremi",
  "session_expired": "Vaša sesija je istekla. Molimo prijavite se ponovo.",
  "nav_services": "Usluge",
  "nav_portal": "Portal",
  "nav_credits": "Krediti",
  "hero_online": "Online",
  "hero_digital_partner": "Digitalni partner",
  "business_solutions": "Poslovna rješenja",
  "personal_solutions": "Osobna rješenja",
  "enterprise_desc": "Profesionalne digitalne usluge za rast vašeg poslovanja.",
  "personal_desc": "Pametni investicijski alati i edukacija za osobni rast.",
  "services_hero_title": "Naše usluge",
  "services_hero_desc": "Od osnovnih web stranica do naprednih pametnih rješenja. Isporučujemo digitalnu izvrsnost.",
  "get_started": "Započnite",
  "get_a_quote": "Zatražite ponudu",
  "free_seo_audit": "Besplatni SEO audit",
  "ready_to_start": "Spremni za početak?",
  "ready_to_build": "Spremni za nešto nevjerojatno?",
  "ready_to_build_sub": "Razgovarajte s Ristom za personaliziranu ponudu.",
  "trusted_worldwide": "Povjerenje diljem svijeta",
  "chat_placeholder": "Upišite poruku...",
  "chat_suggested_1": "Trebam web stranicu",
  "chat_suggested_2": "Ispričajte mi o uslugama",
  "chat_suggested_3": "Želim pametnu uslugu",
  "chat_suggested_4": "Dobiti procjenu cijene",
  "trust_platform": "Pouzdana platforma",
  "trust_security": "Korporativna sigurnost",
  "trust_ai": "Pametna tehnologija",
  "trust_global": "Globalni doseg",
  "back_to_home": "Povratak na početnu",
  "continue_google": "Nastavi s Googleom",
  "continue_facebook": "Nastavi s Facebookom",
  "continue_github": "Nastavi s GitHubom",
  "or_continue_email": "ili nastavi s emailom",
  "two_factor_auth": "Dvofaktorska autentifikacija",
  "enter_2fa_code": "Unesite kod iz aplikacije za autentifikaciju",
  "verify_btn": "Potvrdi kod",
  "verifying": "Provjera...",
  "use_different_account": "Koristi drugi račun",
  "session_expired_msg": "Vaša sesija je istekla zbog neaktivnosti. Molimo prijavite se ponovo.",
  "nav_home": "Početna",
  "nav_back": "Natrag",
  "my_account": "Moj račun",
  "sign_out": "Odjava",
  "client_portal": "Klijentski portal",
  "your_projects": "Vaši projekti",
  "your_invoices": "Vaši računi",
  "projects": "Projekti",
  "invoices_tab": "Računi",
  "milestones": "Prekretnice",
  "messages": "Poruke",
  "no_projects": "Još nema projekata. Vaši projekti pojavit će se ovdje.",
  "no_invoices": "Još nema računa.",
  "no_messages": "Još nema poruka. Započnite razgovor s timom.",
  "type_message": "Unesite poruku...",
  "back_to_projects": "Natrag na projekte",
  "budget_label": "Budžet",
  "progress_label": "Napredak",
  "service_label": "Usluga",
  "portal_locked_desc": "Klijentski portal dostupan je odobrenim klijentima.",
  "contact_to_start": "Kontaktirajte nas",
  "quick_web_dev": "Web razvoj",
  "quick_mobile": "Mobilna aplikacija",
  "quick_crypto": "Kripto edukacija",
  "quick_get_quote": "Zatražite ponudu",
  "quick_tell_more": "Recite mi više",
  "quick_have_project": "Imam projekt",
  "quick_submit": "Pošalji zahtjev",
  "get_cost_estimate": "Procjena troškova",
  "choose_plan": "Odaberite plan",
  "choose_plan_desc": "Skalirajte posao s pravim planom.",
  "current_free_plan": "Trenutni besplatni plan",
  "svc_ecommerce_label": "E-trgovina / Web trgovina",
  "svc_ecommerce_desc": "Kompletne online trgovine s integracijom plaćanja",
  "svc_seo_label": "SEO i digitalni marketing",
  "svc_seo_desc": "Optimizacija za tražilice i strategija rasta",
  "svc_hosting_label": "Upravljani hosting",
  "svc_hosting_desc": "Sigurna, brza i pouzdana hosting infrastruktura",
  "svc_advertising_label": "Digitalno oglašavanje",
  "svc_advertising_desc": "PPC, društveni oglasi i performansni marketing",
  "svc_trading_label": "Konzultacije o trgovanju",
  "svc_trading_desc": "Stručno vođene sesije strategije trgovanja",
  "svc_domains_label": "Upravljanje domenama",
  "svc_domains_desc": "Registracija domena, DNS upravljanje i transferi",
  "svc_ecommerce_price": "Od €799",
  "svc_seo_price": "Od €299/mj",
  "svc_hosting_price": "Od €29/mj",
  "svc_advertising_price": "Od €499/mj",
  "svc_trading_price": "Od €149/sesija",
  "svc_domains_price": "Od €19/god",
  "testimonials_title": "Što kažu naši klijenti",
  "testimonials_subtitle": "Tvrtke diljem Europe nam vjeruju",
  "stat_projects": "Isporučenih projekata",
  "stat_satisfaction": "Zadovoljstvo klijenata",
  "stat_languages": "Podržanih jezika",
  "all_rights_reserved": "Sva prava pridržana.",
  "form_your_name": "Vaše ime",
  "form_your_email": "Vaš email",
  "form_describe_need": "Opišite što trebate...",
  "form_additional_feedback": "Dodatni komentari? (opcionalno)",
  "form_email_followup": "Vaš email (opcionalno, za povratnu informaciju)",
  "form_budget_range": "Raspon proračuna",
  "form_timeline": "Vremenski okvir",
  "form_cancel": "Odustani",
  "form_select_services": "Odaberite usluge (više moguće):",
  "rating_title": "Ocijenite svoje iskustvo s RisTA",
  "rating_helpful": "Koliko je ovaj razgovor bio koristan?",
  "rating_overall": "Ukupno iskustvo s asistentom",
  "rating_recommend": "Biste li preporučili RisTA?",
  "rating_yes": "Da",
  "rating_no": "Ne",
  "rating_submit": "Pošalji ocjenu",
  "rating_skip": "Preskoči",
  "rating_thanks": "Hvala na povratnoj informaciji!",
  "generating_estimate": "Generiranje procjene troškova...",
  "profile_info": "Podaci o profilu",
  "profile_name": "Ime",
  "profile_email": "Email",
  "profile_role": "Uloga",
  "profile_member_since": "Član od",
  "profile_rerun_onboarding": "Ponovo pokreni uvod",
  "profile_language_pref": "Preferirani jezik",
  "profile_language_saved": "Jezična postavka spremljena!",
  "privacy_heading": "Politika privatnosti",
  "terms_heading": "Uvjeti korištenja",
  "about_heading": "O Infinity Business",
  "walkthrough_heading": "Vodiči",
  "nav_tools": "Alati",
  "nav_marketplace": "Tržnica",
  "chat_digital_partner": "Digitalni partner",
  "chat_online": "Online",
  "chat_help_text": "Mogu pomoći s web razvojem, mobilnim aplikacijama, dizajnom, kriptom i više.",
  "chat_your_partner": "Vaš digitalni partner",
  "chat_assistant_subtitle": "Razgovarajte s vašim pametnim asistentom",
  "tab_password": "Lozinka",
  "tab_rista_services": "RisTA usluge",
  "tab_analytics": "Analitika",
  "tab_projects": "Projekti",
  "tab_referral": "Program preporuka",
  "marketplace_title": "Tržnica predložaka",
  "marketplace_subtitle": "Premium predlošci koje možete prilagoditi. Profesionalna kvaliteta, spremni za korištenje.",
  "marketplace_search": "Pretraži predloške...",
  "marketplace_purchase": "Kupi",
  "marketplace_preview": "Pregled",
  "marketplace_all": "Sve",
  "marketplace_category_website": "Web stranica",
  "marketplace_category_brand": "Brand",
  "marketplace_category_resume": "Životopis",
  "marketplace_downloads": "preuzimanja",
  "marketplace_close_preview": "Zatvori pregled",
  "marketplace_features": "Značajke",
  "marketplace_live_preview": "Pregled uživo",
  "case_studies_title": "Priče o uspjehu klijenata",
  "case_studies_subtitle": "Stvarni rezultati stvarnih tvrtki. Pogledajte transformaciju.",
  "case_studies_before": "Prije",
  "case_studies_after": "Poslije",
  "case_studies_cta_title": "Spremni za rast vašeg poslovanja?",
  "case_studies_cta_desc": "Pridružite se ovim tvrtkama i postignite slične rezultate s našim pametnim uslugama.",
  "case_studies_cta_btn": "Započnite",
  "profile_go_homepage": "Idi na početnu",
  "onboarding_welcome_title": "Dobrodošli u Infinity Business",
  "onboarding_welcome_subtitle": "Vaš pametni digitalni partner",
  "onboarding_welcome_content": "Infinity Business nudi sveobuhvatne B2B i P2P digitalne usluge. Naš pametni asistent RisTA vodit će vas kroz sve.",
  "onboarding_welcome_item1": "Intelligent System procjena projekata",
  "onboarding_welcome_item2": "Web, mobilne i dizajn usluge",
  "onboarding_welcome_item3": "Kripto edukacija i investicijski alati",
  "onboarding_welcome_item4": "Personalizirane konzultacije",
  "onboarding_services_title": "Istražite naše usluge",
  "onboarding_services_subtitle": "Dvije kategorije prilagođene vama",
  "onboarding_services_content": "Nudimo dvije kategorije usluga:",
  "onboarding_services_item1": "B2B: Web razvoj, mobilne aplikacije, grafički dizajn, hosting, softver, oglašavanje",
  "onboarding_services_item2": "P2P: Kripto edukacija, investicijski alati, trading, domene, DeFi",
  "onboarding_services_item3": "Intelligent System usluge: Životopis, poslovni plan, SEO izvještaji, brand paketi i više",
  "onboarding_services_item4": "Razgovarajte s RisTA bilo kada za personaliziranu ponudu",
  "onboarding_credits_title": "Sustav kredita",
  "onboarding_credits_subtitle": "Prepaid stanje za pametne usluge",
  "onboarding_credits_content": "Koristite kredite za trenutni pristup našim pametnim uslugama:",
  "onboarding_credits_item1": "Nadopunite stanje bilo kada (min. 5, maks. 1.000)",
  "onboarding_credits_item2": "Krediti se automatski oduzimaju pri korištenju pametnih usluga",
  "onboarding_credits_item3": "Uvijek ćete biti upitani prije oduzimanja",
  "onboarding_credits_item4": "Pregledajte stanje i povijest u panelu kredita",
  "onboarding_chat_title": "Razgovarajte s RisTA",
  "onboarding_chat_subtitle": "Vaš digitalni partner je spreman",
  "onboarding_chat_content": "RisTA vam može pomoći s:",
  "onboarding_chat_item1": "Procjenama i ponudama projekata",
  "onboarding_chat_item2": "Detaljnim pregledom opcija usluga",
  "onboarding_chat_item3": "Slanjem zahtjeva za usluge",
  "onboarding_chat_item4": "Odgovaranjem na pitanja na 11 jezika",
  "onboarding_next": "Dalje",
  "onboarding_get_started": "Započni",
  "onboarding_back": "Natrag",
  "onboarding_biz_title": "Odabir usluga",
  "onboarding_biz_subtitle": "Što najbolje opisuje vaše potrebe?",
  "onboarding_biz_content": "Pomozite nam preporučiti prave usluge za vas:",
  "onboarding_biz_type_startup": "Startup / Novo poslovanje",
  "onboarding_biz_type_smb": "Malo-srednje poduzeće",
  "onboarding_biz_type_enterprise": "Veliko poduzeće / Korporacija",
  "onboarding_biz_type_freelancer": "Freelancer / Pojedinac",
  "onboarding_biz_type_investor": "Investitor / Kripto entuzijast",
  "change_password_title": "Promjena lozinke",
  "referral_title": "Program preporuka",
  "referral_generate": "Generiraj moj kod za preporuku",
  "referral_redeem_title": "Iskoristi kod",
  "referral_redeem_btn": "Iskoristi",
  "referral_referrals": "Preporuke",
  "referral_rewards": "Nagrade",
  "referral_copy_link": "Kopiraj link",
  "referral_copied": "Kopirano!",
  "project_tracker_title": "Praćenje projekata",
  "project_no_projects": "Još nema projekata. Projekti će se pojaviti ovdje nakon kupnje usluge.",
  "analytics_total_services": "Ukupno usluga",
  "analytics_completed": "Završeno",
  "analytics_pending": "Na čekanju",
  "analytics_total_spent": "Ukupno potrošeno",
  "analytics_credit_balance": "Stanje kredita",
  "analytics_recent": "Nedavne usluge",
  "billing_management": "Upravljanje naplatom",
  "billing_manage_btn": "Upravljaj naplatom",
  "billing_cancel_btn": "Otkaži plan",
  "plan_features": "Značajke vašeg plana",
  "nav_try_free": "Isprobaj besplatno",
  "profile_appearance": "Izgled i pristupačnost",
  "profile_theme": "Tema",
  "profile_text_size": "Veličina teksta",
  "profile_text_size_hint": "Prilagodite veličinu teksta za lakše čitanje.",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_1_text": "RisTA nam je pomogla izgraditi cjelokupnu web prisutnost u samo 2 tjedna. pametna konzultacija je nevjerojatno točno razumjela naše potrebe.",
  "testimonial_2_role": "Direktorica marketinga, BioFresh",
  "testimonial_2_text": "Paket brenda i kalendar društvenih mreža uštedili su nam mjesece rada. Kvaliteta je premašila ono što smo dobili od tradicionalnih agencija.",
  "testimonial_3_role": "Slobodni programer",
  "testimonial_3_text": "Redovito koristim alat za životopise i analizu konkurencije. pametni rezultati su spremni za produkciju, a kreditni sustav čini cijene transparentnima.",
  "services_cta_title": "Spremni za početak?",
  "services_cta_desc": "Razgovarajte s RisTA, našim inteligentnim digitalnim asistentom, za personaliziranu ponudu vašeg projekta.",
  "services_talk_rista": "Razgovarajte s RisTA",
  "services_free_audit": "Besplatni SEO pregled",
  "tools_title": "Besplatni marketinski alati",
  "tools_subtitle": "Isprobajte naše besplatne alate - bez registracije",
  "sp_basic_web_name": "Izrada osnovne web stranice",
  "sp_basic_web_desc": "Profesionalna web stranica za vaše poslovanje s modernim dizajnom i potpunom mobilnom kompatibilnošću.",
  "sp_basic_web_feat": "Moderan responzivan dizajn|Do 5 stranica|Integracija kontakt obrasca|Optimizirano za mobilne|Osnovno SEO postavljanje|Pomoć pri unosu sadržaja",
  "sp_web_store_name": "Web trgovina / E-Commerce",
  "sp_web_store_desc": "Potpuna e-commerce platforma s integriranim plaćanjima i marketinškim alatima.",
  "sp_web_store_feat": "Kompletna online trgovina|Obrada plaćanja|Upravljanje proizvodima|Praćenje narudžbi|SEO optimizacija|Marketinška strategija uključena",
  "sp_custom_web_name": "Prilagođena web aplikacija",
  "sp_custom_web_desc": "Web aplikacije izrađene prema vašim točnim poslovnim zahtjevima.",
  "sp_custom_web_feat": "Prilagođeni softverski dizajn|API integracije|Arhitektura baze podataka|Skalabilna infrastruktura|Admin nadzorne ploče|Stalna podrška",
  "sp_mobile_app_name": "Mobilna aplikacija",
  "sp_mobile_app_desc": "Nativne i cross-platform mobilne aplikacije za iOS i Android.",
  "sp_mobile_app_feat": "iOS i Android|Cross-platform razvoj|Push obavijesti|Objava u trgovinama|UI/UX dizajn|Backend integracija",
  "sp_seo_name": "SEO i digitalni marketing",
  "sp_seo_desc": "Povećajte svoju online vidljivost sveobuhvatnim SEO i digitalnim marketinškim strategijama.",
  "sp_seo_feat": "Potpuna SEO revizija|Optimizacija ključnih riječi|Strategija sadržaja|Upravljanje Google Ads|Marketing na društvenim mrežama|Mjesečna izvješća",
  "sp_graphic_name": "Grafički dizajn i brendiranje",
  "sp_graphic_desc": "Kompletna rješenja za brendiranje i grafički dizajn za vaš poslovni identitet.",
  "sp_graphic_feat": "Dizajn logotipa|Identitet brenda|Marketinški materijali|Grafike za društvene mreže|Dizajn za tisak|Vodič za stil",
  "sp_crypto_edu_name": "Program kripto edukacije",
  "sp_crypto_edu_desc": "Naučite trgovanje kriptovalutama i blockchain tehnologiju od stručnjaka.",
  "sp_crypto_edu_feat": "Osnove blockchaina|Strategije trgovanja|Sigurnost novčanika|Uvod u DeFi|Analiza tržišta|Osobno mentorstvo",
  "sp_invest_name": "Pametni investicijski alati",
  "sp_invest_desc": "Profesionalni alati za praćenje investicija i analizu pokretani pametnim sustavom.",
  "sp_invest_feat": "Praćenje portfelja|Nadzorna ploča tržišta|pametni uvidi|Procjena rizika|Upozorenja u stvarnom vremenu|Podrška za više burzi",
  "sp_ad_name": "Usluge oglašavanja",
  "sp_ad_desc": "Dosegnite milijune kroz našu mrežu portala u više regija.",
  "sp_ad_feat": "20+ mreža portala|10M+ doseg|Ciljane kampanje|Praćenje performansi|Oglasi na više platformi|Optimizacija ROI-a",
  "contact_heading": "Kontaktirajte nas",
  "contact_subtitle_text": "Imate pitanje ili želite razgovarati o projektu? Rado ćemo vas saslušati.",
  "contact_name_label": "Ime",
  "contact_email_label": "Email",
  "contact_subject_label": "Predmet",
  "contact_message_label": "Poruka",
  "contact_name_ph": "Vaše ime",
  "contact_email_ph": "vi@primjer.com",
  "contact_subject_ph": "O čemu se radi?",
  "contact_message_ph": "Opišite svoj projekt ili pitanje...",
  "contact_send_btn": "Pošalji poruku",
  "contact_sending": "Slanje...",
  "contact_sent_title": "Poruka poslana!",
  "contact_sent_msg": "Hvala vam na poruci. Odgovorit ćemo vam unutar 24 sata.",
  "contact_send_another": "Pošalji drugu poruku",
  "contact_info_email": "Email",
  "contact_info_location": "Lokacija",
  "contact_info_eu": "Europska unija",
  "contact_info_response": "Vrijeme odgovora",
  "contact_info_response_time": "Unutar 24 sata",
  "contact_info_hours": "Pon - Pet, 9:00 - 18:00 CET",
  "tf_seo_name": "Besplatna SEO revizija",
  "tf_seo_desc": "Dobijte sveobuhvatnu SEO analizu bilo koje web stranice - nije potrebna registracija.",
  "tf_color_name": "Generator palete boja",
  "tf_color_desc": "Generirajte prekrasne, harmonične palete boja za vaš brend.",
  "tf_headline_name": "Analizator naslova",
  "tf_headline_desc": "Ocijenite svoje naslove za potencijal klikanja i emocionalni utjecaj.",
  "tf_chat_name": "Razgovarajte s Ristom",
  "tf_chat_desc": "Dobijte trenutne procjene projekata, istražite usluge i postavljajte pitanja na 11 jezika.",
  "tf_free_label": "Besplatno",
  "tools_seo_title": "Brza SEO provjera",
  "tools_seo_desc": "Trenutna SEO ocjena za bilo koju web stranicu",
  "tools_seo_ph": "Unesite URL web stranice (npr. primjer.com)",
  "tools_analyze": "Analiziraj",
  "tools_color_title": "Generator palete boja",
  "tools_color_desc": "Generirajte komplementarne palete boja",
  "tools_headline_title": "Analizator naslova",
  "tools_headline_desc": "Analizirajte učinkovitost naslova",
  "tools_headline_ph": "Unesite svoj naslov...",
  "tools_headline_btn": "Analiziraj naslov",
  "tools_issues": "Pronađeni problemi",
  "tools_suggestions": "Prijedlozi",
  "tools_score": "Rezultat",
  "docs_heading": "Značajke platforme",
  "docs_subtitle": "Sve što Infinity Business nudi za vaš digitalni put.",
  "docs_no_data": "Nema dostupne dokumentacije.",
  "tester_heading": "Postanite tester",
  "tester_subtitle": "Pomozite nam poboljšati platformu i dobijte besplatan pristup uslugama.",
  "tester_req_title": "Što je potrebno",
  "tester_req_1": "Prijavite se najmanje 5 puta tjedno",
  "tester_req_2": "Pošaljite najmanje 10 izvješća o greškama/povratnim informacijama tjedno",
  "tester_req_3": "Testirajte različite značajke, stranice i korisničke tokove",
  "tester_benefit_title": "Što dobivate",
  "tester_benefit_1": "Besplatan pristup uslugama inteligentnog sustava (na zahtjev)",
  "tester_benefit_2": "Nadzorna ploča testera s praćenjem napretka",
  "tester_benefit_3": "Prioritetna podrška od tima",
  "tester_apply_title": "Prijavite se",
  "tester_motivation": "Zašto želite biti tester?",
  "tester_motivation_ph": "Recite nam zašto biste željeli pomoći u testiranju platforme...",
  "tester_experience": "Iskustvo testiranja (opcionalno)",
  "tester_experience_ph": "Bilo kakvo relevantno iskustvo...",
  "tester_submit_app": "Pošalji prijavu",
  "tester_applied_title": "Prijava poslana",
  "tester_applied_msg": "Naš admin će pregledati vašu prijavu i bit ćete obaviješteni.",
  "tester_need_account": "Trebate račun za prijavu.",
  "tester_dash_title": "Nadzorna ploča testera",
  "tester_dash_desc": "Održavajte svoj status testera ispunjavanjem tjednih ciljeva.",
  "tester_weekly_logins": "Tjedne prijave",
  "tester_weekly_reports": "Tjedna izvješća",
  "tester_target_met": "Cilj postignut!",
  "tester_logins_needed": "potrebno još prijava ovaj tjedan",
  "tester_reports_needed": "potrebno još izvješća ovaj tjedan",
  "tester_total_reports": "Ukupno poslanih izvješća",
  "tester_on_track": "Na pravom putu",
  "tester_at_risk": "Pod rizikom",
  "tester_report_heading": "Pošalji izvješće o grešci / povratnu informaciju",
  "tester_report_title_ph": "Naslov (npr. 'Gumb ne radi na mobilnom')",
  "tester_report_desc_ph": "Opišite problem ili prijedlog detaljno...",
  "tester_report_page_ph": "URL stranice (opcionalno)",
  "tester_submit_report": "Pošalji izvješće",
  "seo_page_title": "Besplatna SEO revizija",
  "seo_page_desc": "Unesite URL bilo koje web stranice za sveobuhvatnu SEO analizu s preporukama.",
  "seo_page_ph": "Unesite URL web stranice (npr. primjer.com)",
  "seo_page_btn": "Pokreni reviziju",
  "seo_page_running": "Analiziranje...",
  "seo_page_error": "Nije moguće analizirati ovu stranicu. Provjerite URL i pokušajte ponovo.",
  "referral_reward_title": "Kako nagrade funkcioniraju",
  "referral_reward_desc": "Zaradite 10% od svake kupnje korisnika koje preporučite, automatski dodano na vaš račun kao besplatni krediti.",
  "referral_reward_1": "Podijelite svoj jedinstveni link za preporuku s prijateljima",
  "referral_reward_2": "Kada oni obave kupnju, vi zarađujete 10% kao besplatne kredite",
  "referral_reward_3": "Krediti se automatski dodaju na vaš saldo",
  "referral_earned_label": "Zarađeni krediti",
  "profile_picture": "Profilna slika",
  "profile_bio": "Biografija",
  "profile_website": "Web stranica",
  "profile_interests": "Interesi",
  "profile_upload_photo": "Učitaj fotografiju",
  "profile_bio_ph": "Recite nam o sebi...",
  "profile_website_ph": "https://vasastranica.com",
  "profile_interests_ph": "npr. Web razvoj, Kripto, Tech",
  "profile_save": "Spremi profil",
  "admin_notes": "Admin bilješke",
  "admin_notes_ph": "Dodajte bilješku o ovom korisniku...",
  "admin_notes_add": "Dodaj bilješku",
  "sub_most_popular": "Najpopularnije",
  "sub_free": "Besplatno",
  "sub_one_time": "jednokratno",
  "sub_team_members": "Članovi tima",
  "sub_members_info": "Pozovite članove tima da dijele vaš plan. Svaki član dobiva vlastitu prijavu i pristup uslugama.",
  "sub_show_less": "Prikaži manje",
  "sub_more_features": "više značajki",
  "sub_pay_with": "Plati s",
  "sub_preferred": "preferirano",
  "sub_live_crypto": "Cijene kriptovaluta uživo (EUR i USD)",
  "sp_logo_name": "Dizajn Logotipa",
  "sp_logo_desc": "Profesionalni dizajn logotipa koji obuhvaća bit vašeg branda.",
  "sp_logo_feat": "3 jedinstvena koncepta|Neograničene revizije|Vektorske datoteke|Boja + C/B|Smjernice branda|Social media kit",
  "sp_brand_name": "Potpuni Identitet Branda",
  "sp_brand_desc": "Potpuni paket identiteta branda s logom, paletom boja i smjernicama.",
  "sp_brand_feat": "Logo|Paleta boja|Tipografija|Posjetnica|Memorandum|PDF smjernice|Social predlošci",
  "sp_poster_name": "Dizajn Plakata",
  "sp_poster_desc": "Privlačni dizajni plakata za događanja i reklamne kampanje.",
  "sp_poster_feat": "Prilagođena ilustracija|Datoteke za tisak|Više veličina|2 kruga revizije|Visoka rezolucija|Digitalno + tisak",
  "sp_flyer_name": "Dizajn Letka",
  "sp_flyer_desc": "Profesionalni dizajni letaka za marketing i događanja.",
  "sp_flyer_feat": "Prednja i stražnja strana|PDF za tisak|Digitalna verzija|QR kod|2 revizije|Više formata",
  "sp_menu_name": "Dizajn Jelovnika",
  "sp_menu_desc": "Prekrasni dizajni jelovnika za restorane i kafiće.",
  "sp_menu_feat": "Prilagođeni raspored|Integracija fotografija|QR verzija|Datoteke za tisak|Sezonsko ažuriranje|Više stranica",
  "currency_label": "Valuta",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Mi smo tehnološka tvrtka usmjerena na pametna digitalna rješenja. Osnovana 2026., Infinity Business kombinira pametne inovacije s dokazanom stručnošću.",
  "about_values": "Naše Vrijednosti",
  "about_what_we_do": "Što Radimo",
  "about_meet_rista": "Upoznajte Ristu",
  "about_rista_desc": "RisTA je naš inteligentni pametni asistent. Pomaže u kvalifikaciji zahtjeva, nudi trenutačne savjete i povezuje vas s našim timom. Dostupan 24/7, višejezičan.",
  "about_talk_rista": "Razgovarajte s Ristom",
  "about_val_trust": "Povjerenje i Sigurnost",
  "about_val_trust_desc": "Primjenjujemo najviše standarde zaštite podataka.",
  "about_val_innovation": "Inovacija",
  "about_val_innovation_desc": "Najnovija pametna tehnologija pokreće naša rješenja.",
  "about_val_partnership": "Partnerstvo",
  "about_val_partnership_desc": "Radimo uz vas kao pravi partner.",
  "about_val_global": "Globalni Doseg",
  "about_val_global_desc": "Naša rješenja su dizajnirana za međunarodna tržišta.",
  "about_svc_web": "Web Razvoj",
  "about_svc_web_desc": "Full-stack web aplikacije, e-commerce platforme i CMS rješenja.",
  "about_svc_mobile": "Mobilne Aplikacije",
  "about_svc_mobile_desc": "Nativne i cross-platform aplikacije za iOS i Android.",
  "about_svc_software": "Prilagođeni Softver",
  "about_svc_software_desc": "Softverska rješenja po mjeri za automatizaciju poslovnih procesa.",
  "about_svc_invest": "Pametna Ulaganja",
  "about_svc_invest_desc": "pametni alati za kripto i DeFi s profesionalnim uslugama trgovanja.",
  "micro_tools_title": "Pametni mikro-alati",
  "micro_tools_subtitle": "Trenutni pametni uvidi za generiranje leadova, istraživanje tržišta i strateško planiranje.",
  "micro_tools_all": "Sve",
  "micro_tools_try": "Isprobaj",
  "micro_tools_generate_free": "Generiraj (Besplatno)",
  "micro_tools_generate_paid": "Generiraj",
  "micro_tools_close": "Zatvori",
  "micro_tools_interested": "Zainteresirani?",
  "tools_view_service": "Pogledaj uslugu",
  "tools_talk_rista": "Razgovaraj s RisTA",
  "competitor_title": "Pametna analiza konkurencije",
  "competitor_desc": "Unesite URL konkurenta za pametnu analizu sa SEO usporedbom i pregledom dizajna.",
  "competitor_url_ph": "Unesite URL konkurenta",
  "competitor_analyze": "Analiziraj konkurenta",
  "competitor_score": "Ukupna ocjena",
  "competitor_seo": "SEO analiza",
  "competitor_design": "Analiza dizajna",
  "competitor_content": "Analiza sadržaja",
  "competitor_strengths": "Prednosti",
  "competitor_weaknesses": "Slabosti",
  "competitor_opportunities": "Prilike",
  "competitor_recommendations": "Preporuke",
  "accessibility_title": "Provjera pristupačnosti",
  "accessibility_desc": "Provjera standarda pristupačnosti",
  "cat_lead_gen": "Lead-Gen & Promet",
  "cat_discovery": "Otkrivanje izvještaja",
  "cat_email": "E-mail & Workflow",
  "cat_planning": "Planiranje & Strategija",
  "cat_content": "Sadržaj & Pozicioniranje",
  "sp_health_score_name": "Ocjena zdravlja web stranice",
  "sp_health_score_feat": "SEO analiza|Provjera performansi|Sigurnosni sken|Revizija pristupačnosti|Detaljno izvješće|Savjeti za poboljšanje",
  "sp_hosting_name": "Upravljani web hosting",
  "sp_hosting_desc": "Siguran, brz i pouzdan hosting za vaše web stranice i aplikacije.",
  "sp_hosting_feat": "99.9% dostupnost|SSL certifikati|Dnevne sigurnosne kopije|CDN integracija|24/7 nadzor|Auto-skaliranje",
  "sp_biz_plan_name": "Pametni poslovni plan",
  "sp_biz_plan_desc": "Generirajte sveobuhvatni poslovni plan s financijama, analizom tržišta i strategijom rasta.",
  "sp_biz_plan_feat": "Sažetak|Analiza tržišta|Financijske projekcije|Pregled konkurencije|Strategija rasta|Format za investitore",
  "sp_seo_report_name": "Izvješće o reviziji web stranice",
  "sp_seo_report_desc": "Automatizirana analiza stranice s preporukama za SEO i uvide u performanse.",
  "sp_seo_report_feat": "100+ provjera|Metrike performansi|SEO preporuke|Mobilna analiza|Sigurnosni pregled|Akcijski plan",
  "sp_email_campaign_name": "Postavljanje email marketinga",
  "sp_email_campaign_desc": "Profesionalno postavljanje email kampanje s tekstom, sekvencama i ciljanjem publike.",
  "sp_email_campaign_feat": "Pisanje emailova|Postavljanje sekvenci|Ciljanje publike|A/B testiranje|Postavljanje analitike|Dizajn predloška",
  "sp_competitor_name": "Analiza konkurencije",
  "sp_competitor_desc": "Duboka konkurentska inteligencija sa SEO usporedbom, pregledom dizajna i analizom sadržaja.",
  "sp_competitor_feat": "SEO usporedba|Pregled dizajna|Praznine u sadržaju|Tržišno pozicioniranje|SWOT analiza|Strateške preporuke",
  "sp_legal_docs_name": "Generator pravnih dokumenata",
  "sp_legal_docs_desc": "Profesionalni pravni predlošci uključujući NDA, ugovore i Uvjete korištenja.",
  "sp_legal_docs_feat": "NDA predlošci|Ugovori o usluzi|Uvjeti korištenja|Pravila privatnosti|GDPR usklađenost|Prilagođene klauzule",
  "sp_resume_name": "Pametni kreator životopisa",
  "sp_resume_desc": "Izradite ATS-optimizirane životopise prilagođene vašoj ciljnoj poziciji i industriji.",
  "sp_resume_feat": "ATS optimizacija|Industrijski predlošci|Podudaranje ključnih riječi|Motivacijsko pismo|LinkedIn optimizacija|PDF izvoz",
  "sp_brand_kit_name": "Pametni logo i brend paket",
  "sp_brand_kit_desc": "Kompletni paket brendiranja s konceptima logotipa, paletom boja i materijalima za društvene mreže.",
  "sp_brand_kit_feat": "Koncepti logotipa|Paleta boja|Tipografija|Materijali za društvene mreže|Smjernice brenda|Set ikona",
  "sp_social_cal_name": "Kalendar društvenih mreža",
  "sp_social_cal_desc": "30 dana pametno generiranih objava na društvenim mrežama sa strategijom angažmana.",
  "sp_social_cal_feat": "30-dnevni kalendar|Tekst objava|Strategija hashtagova|Savjeti za angažman|Najbolja vremena za objavu|Optimizacija po platformi",
  "sp_translation_name": "Pametno prevođenje",
  "sp_translation_desc": "Profesionalno prevođenje dokumenata na 50+ jezika s kulturnom prilagodbom.",
  "sp_translation_feat": "50+ jezika|Kulturna prilagodba|Tehnički pojmovi|Brza isporuka|Lektura|Očuvanje formata",
  "sp_video_script_name": "Pametni pisac video scenarija",
  "sp_video_script_desc": "Scenariji za YouTube, TikTok i oglase optimizirani za maksimalni angažman.",
  "sp_video_script_feat": "YouTube scenariji|TikTok sadržaj|Tekstovi oglasa|Optimizacija uvoda|Poziv na akciju|Savjeti za angažman",
  "sp_free_seo_name": "Besplatna SEO revizija",
  "sp_free_seo_desc": "Pokrenite besplatnu sveobuhvatnu SEO reviziju za bilo koju web stranicu.",
  "sp_free_seo_feat": "Trenutni rezultati|100+ provjera|Ocjena performansi|Mobilna provjera|Sigurnosni sken|Besplatno izvješće",
  "sp_free_tools_name": "Besplatni digitalni alati",
  "sp_free_tools_desc": "Pristupite našoj kolekciji besplatnih alata.",
  "sp_free_tools_feat": "Generator palete boja|Analizator naslova|Generator lozinki|QR kod kreator|Pretvarač jedinica|Bez registracije",
  "sp_tools_title": "Pametne mikro-usluge",
  "sp_tools_desc": "Trenutne pametne usluge za sadržaj, brendiranje, analizu i profesionalne dokumente.",
  "sp_free_title": "Besplatni alati",
  "sp_free_desc": "Isprobajte našu platformu s ovim besplatnim alatima. Nije potreban račun.",
  "a11y_checker": "Provjera pristupačnosti",
  "a11y_compliant": "Sukladno",
  "a11y_disclaimer": "Automatske provjere pokrivaju ~30% problema pristupačnosti. Preporučuje se ručno testiranje čitačima zaslona.",
  "a11y_error": "Revizija nije uspjela. Pokušajte ponovo.",
  "a11y_incomplete": "potreban pregled",
  "a11y_issues_found": "Pronađeni problemi",
  "a11y_no_issues": "Nema problema s pristupačnošću!",
  "a11y_passed": "prošlo",
  "a11y_rescan": "Ponovo skeniraj",
  "a11y_scanning": "Pokretanje WCAG revizije...",
  "a11y_violations": "prekršaji",
  "admin_ab_testing": "A/B testiranje",
  "admin_account_mgmt": "Upravljanje računima",
  "admin_actions": "Akcije",
  "admin_active": "Aktivno",
  "admin_ad_gen": "Generator oglasa",
  "admin_add_milestone": "Dodaj prekretnicu",
  "admin_adv_reports": "Napredni izvještaji",
  "admin_ai_config": "Konfiguracija modela",
  "admin_ai_prompts": "Pametni upiti",
  "admin_analytics": "Analitika",
  "admin_audit": "Revizija platforme",
  "admin_audit_trail": "Revizijski trag",
  "admin_auto_posting": "Pametno automatsko objavljivanje",
  "admin_avatar_builder": "Graditelj avatara",
  "admin_avatar_selector": "Odabir avatara",
  "admin_avg_exp": "Prosj. iskustvo",
  "admin_avg_rating": "Prosj. ocjena",
  "admin_backup": "Sigurnosna kopija",
  "admin_billing": "Ponavljajuća naplata",
  "admin_blog": "Upravitelj bloga",
  "admin_bug_reports": "Prijave grešaka",
  "admin_cancel": "Otkaži",
  "admin_cdn": "CDN upravitelj",
  "admin_chat_analytics": "Analitika razgovora",
  "admin_chat_sessions": "Sesije razgovora",
  "admin_client_portal": "Klijentski portal",
  "admin_abandoned_carts": "Napuštene košarice",
  "rista_login_required": "Potrebna prijava",
  "rista_login_desc": "Prijavite se ili kreirajte račun za razgovor s RisTA-om i dobijte personalizirane poslovne preporuke.",
  "rista_login_btn": "Prijava",
  "rista_signup_btn": "Registracija",
  "admin_created": "Kreirano",
  "admin_credits": "Konfiguracija kredita",
  "admin_crypto_payments": "Kripto plaćanja",
  "admin_crypto_trading": "Kripto trgovanje",
  "admin_currency": "Višestruka valuta",
  "admin_defi": "DeFi stavke",
  "admin_delete": "Obriši",
  "admin_demo": "Demo pristup",
  "admin_demo_banner": "NAČIN SAMO ZA ČITANJE - Demo pregledni račun (Svi korisnički podaci su maskirani)",
  "admin_docs": "Dokumentacija",
  "admin_domain": "Upravitelj domena",
  "admin_edit": "Uredi",
  "admin_email_builder": "Graditelj e-pošte",
  "admin_email_templates": "Predlošci e-pošte",
  "admin_email_templates_desc": "Prilagodite predloške e-pošte vizualnim uređivačem blokova.",
  "admin_escalations": "Eskalacije razgovora",
  "admin_fb": "FB analitika",
  "admin_followups": "Naknadna e-pošta",
  "admin_health": "Monitor zdravlja",
  "admin_health_monitor": "Praćenje zdravlja",
  "admin_health_score": "Ocjena zdravlja",
  "admin_high_leads": "Prioritetni potencijalni klijenti",
  "admin_high_value": "Vrijedni potencijalni klijenti",
  "admin_image_gen": "Generiranje slika",
  "admin_integrations": "Integracije",
  "admin_invoices": "Fakturiranje",
  "admin_kb": "Baza znanja",
  "admin_language_requests": "Zahtjevi za jezike",
  "admin_lead_tracking": "Praćenje potencijalnih klijenata",
  "admin_live_analytics": "Analitika uživo",
  "admin_loading": "Učitavanje...",
  "admin_logo": "Logo i favicon",
  "admin_milestone_desc": "Opis (opcionalno)",
  "admin_milestone_title": "Naslov prekretnice",
  "admin_my_account": "Moj račun",
  "admin_new": "novo",
  "admin_no_data": "Nema dostupnih podataka",
  "admin_no_matching": "Nema odgovarajućih kartica",
  "admin_no_milestones": "Još nema prekretnica. Dodajte prvu!",
  "admin_notifications": "Obavijesti",
  "admin_out_of": "Od",
  "admin_overview": "Pregled",
  "admin_panel": "Administratorska ploča",
  "admin_payment_opts": "Mogućnosti plaćanja",
  "admin_pending": "Na čekanju",
  "admin_portfolio": "Upravitelj portfelja",
  "admin_preloader": "Konfiguracija predučitavanja",
  "admin_pricing": "Dinamičko određivanje cijena",
  "admin_promo": "Promotivni kodovi",
  "admin_rate_limiting": "Ograničenje brzine",
  "admin_rbac": "Kontrola pristupa",
  "admin_referral_board": "Ljestvica preporuka",
  "admin_referrals": "Program preporuka",
  "admin_reports": "Administratorski izvještaji",
  "admin_requests": "Zahtjevi za usluge",
  "admin_reviews": "recenzije",
  "admin_rista": "RisTA usluge",
  "admin_save": "Spremi",
  "admin_score": "Rezultat",
  "admin_search_tabs": "Pretraži kartice...",
  "admin_sendgrid": "E-pošta (SendGrid)",
  "admin_service_mgr": "Upravitelj usluga",
  "admin_sign_out": "Odjava",
  "admin_social": "Društvene mreže",
  "admin_social_auto": "Automatizacija društvenih mreža",
  "admin_social_icons": "Ikone društvenih mreža",
  "admin_status": "Status",
  "admin_surveys": "Ankete zadovoljstva",
  "admin_system_admin": "ADMINISTRATOR SUSTAVA",
  "admin_system_config": "Konfiguracija sustava",
  "admin_tester": "Program testera",
  "admin_timeline": "Vremenska crta projekta",
  "admin_total": "Ukupno",
  "admin_ui_toggles": "UI preklopnici",
  "admin_unread": "Nepročitano",
  "admin_updated": "Ažurirano",
  "admin_users": "Upravljanje korisnicima",
  "admin_view_all": "Pogledaj sve",
  "billing_manage_desc": "Upravljajte načinima plaćanja, pregledajte račune ili ažurirajte podatke o naplati putem Stripe portala.",
  "change_password_btn": "Promijeni lozinku",
  "change_password_confirm": "Potvrdi novu lozinku",
  "change_password_current": "Trenutna lozinka",
  "change_password_new": "Nova lozinka",
  "change_password_social": "Promjena lozinke nije dostupna za račune s društvenom prijavom.",
  "health_a11y": "Pristupačnost",
  "health_desc": "Sveobuhvatna analiza SEO-a, performansi, sigurnosti i pristupačnosti vaše web stranice na jednoj ploči.",
  "health_history": "Povijest skeniranja",
  "health_login_desc": "Kreirajte besplatni račun za skeniranje web stranice i praćenje poboljšanja.",
  "health_login_required": "Prijavite se za korištenje ocjene zdravlja",
  "health_overall": "Ukupna ocjena zdravlja",
  "health_perf": "Performanse",
  "health_premium_badge": "Premium značajka",
  "health_response": "Odgovor",
  "health_scan_btn": "Skeniraj",
  "health_scan_error": "Skeniranje web stranice nije uspjelo. Provjerite URL.",
  "health_scanning": "Skeniranje...",
  "health_security": "Sigurnost",
  "health_seo": "SEO",
  "health_size": "Veličina",
  "health_title": "Ocjena zdravlja web stranice",
  "health_upgrade_btn": "Nadogradite na Premium",
  "health_upsell_desc": "Nadogradite na Premium za automatska tjedna skeniranja, e-mail upozorenja i praćenje trendova.",
  "health_upsell_title": "Želite ponavljajuće praćenje?",
  "health_url_ph": "Unesite URL web stranice (npr. example.com)",
  "nav_currency": "Valuta",
  "nav_health_score": "Ocjena zdravlja",
  "nav_orders": "Moje narudžbe",
  "priority_critical": "Kritično",
  "priority_high": "Visoko",
  "priority_low": "Nisko",
  "priority_medium": "Srednje",
  "profile_about": "O vama",
  "profile_change_avatar": "Promijeni avatar",
  "profile_country": "Zemlja",
  "profile_country_ph": "npr. Njemačka, Hrvatska, SAD",
  "profile_interests_hint": "Razdvojite interese zarezima",
  "seo_cta_desc": "Naša inteligentna SEO revizija pokriva 100+ kontrolnih točaka. Dobijte profesionalnu pomoć za optimizaciju web stranice.",
  "seo_cta_title": "Trebate pomoć s ovim problemima?",
  "sp_health_score": "Ocjena zdravlja web stranice",
  "sp_health_score_desc": "Sveobuhvatna analiza web stranice koja pokriva SEO, performanse, sigurnost i sukladnost pristupačnosti.",
  "status_blocked": "Blokirano",
  "status_completed": "Završeno",
  "status_in_progress": "U tijeku",
  "status_planned": "Planirano",
  "admin_ratings": "Ocjene i povratne informacije",
  "analytics_subscription": "Pretplata",
  "developer_title": "Razvojni API",
  "developer_subtitle": "Integrirajte naše inteligentne usluge u svoje aplikacije",
  "estimate_accept": "Prihvati i pošalji",
  "estimate_revise": "Revidiraj",
  "estimate_title": "Procjena troškova projekta",
  "estimate_service": "Usluga",
  "estimate_complexity": "Složenost",
  "estimate_base_price": "Osnovna cijena",
  "estimate_cost": "Procijenjena cijena",
  "estimate_features": "Ključne značajke",
  "hosting_title": "Paketi hostinga",
  "hosting_subtitle": "Pouzdan, brz hosting za vaš posao",
  "privacy_s1_title": "1. Informacije koje prikupljamo",
  "privacy_s2_title": "2. Kako koristimo vaše podatke",
  "privacy_s3_title": "3. Dijeljenje podataka",
  "privacy_s4_title": "4. Sigurnost podataka",
  "privacy_s5_title": "5. Vaša prava",
  "privacy_s6_title": "6. Kolačići i praćenje",
  "privacy_s7_title": "7. Zadržavanje podataka",
  "privacy_s8_title": "8. Međunarodni prijenosi",
  "privacy_s9_title": "9. Promjene ove politike",
  "privacy_s10_title": "10. Kontaktirajte nas",
  "privacy_intro": "Infinity Business (\"mi\", \"nas\", \"naš\"), kojim upravlja Liber Nostra d.o.o., posvećen je zaštiti vaše privatnosti.",
  "privacy_last_updated": "Zadnje ažuriranje: 7. ožujka 2026.",
  "terms_s1_title": "1. Uvod",
  "terms_s2_title": "2. Usluge",
  "terms_s3_title": "3. Korisnički računi",
  "terms_s4_title": "4. Plaćanja i naplata",
  "terms_s5_title": "5. Odricanje od inteligentnih usluga",
  "terms_s6_title": "6. Intelektualno vlasništvo",
  "terms_s7_title": "7. Privatnost i podaci",
  "terms_s8_title": "8. Odricanje od kriptovaluta",
  "terms_s9_title": "9. Ograničenje odgovornosti",
  "terms_s10_title": "10. Izmjene",
  "terms_s11_title": "11. Mjerodavno pravo",
  "terms_s12_title": "12. Kontakt",
  "terms_last_updated": "Zadnje ažuriranje: veljača 2026",
  "profile_admin_dashboard": "Otvori nadzornu ploču",
  "review_title": "Što naši klijenti kažu",
  "review_subtitle": "Stvarne povratne informacije tvrtki koje smo pomogli",
  "submit_service_request": "Pošaljite zahtjev za uslugu",
  "walkthrough_gmail": "Pametni Gmail asistent",
  "walkthrough_gmail_desc": "Pogledajte kako RisTA organizira vašu pristiglu poštu",
  "walkthrough_calendar": "Osobni savjetnik",
  "walkthrough_calendar_desc": "Kalendar, zadaci i e-pošta putem chata",
  "walkthrough_ai": "Usluge inteligentnog sustava",
  "walkthrough_ai_desc": "Životopis, poslovni planovi, paketi brendova i više",
  "try_free_title": "Besplatni alati i probne usluge",
  "try_free_subtitle": "Bez kreditne kartice. Počnite odmah koristiti naše alate.",
  "try_free_section": "Potpuno besplatno — bez računa",
  "try_free_trial_section": "Usluge inteligentnog sustava — isprobajte s kreditima",
  "try_free_trial_desc": "Registrirajte se za plan kako biste dobili kredite i pristupili pametnim uslugama.",
  "try_free_cta": "Spremni za početak?",
  "try_free_cta_desc": "Kreirajte besplatan račun za prve kredite i otključajte sve pametne usluge.",
  "try_free_cta_btn": "Besplatna registracija",
  "referral_subtitle": "Pozovite prijatelje i zaradite nagrade",
  "support_tickets": "Zahtjevi za podršku",
  "admin_support_tickets": "Zahtjevi za podršku",
  "admin_auto_translate": "Automatski prijevod",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "AI prospekcija",
  "admin_project_mgmt": "Upravljanje projektima",
  "admin_analytics_widget": "Analitički widget",
  "admin_doc_mgmt": "Upravljanje dokumentima",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "Bijela etiketa",
  "admin_multi_tenant": "Višestruki klijenti",
  "popular_services": "Popularne usluge",
  "popular_services_desc": "Najtraženije od strane naših klijenata",
  "purchases": "Kupnje",
  "admin_funnel": "Konverzijski ljevak",
  "admin_wl_licensing": "SaaS licenciranje",
  "admin_analytics_export": "Izvoz analitike",
  "service_detail_features": "Što je uključeno",
  "service_detail_related": "Povezane usluge",
  "service_detail_back": "Sve usluge",
  "checkout_currency": "Valuta naplate",
  "upsell_title": "Dovršite postavljanje",
  "upsell_desc": "Klijenti koji su kupili slično, dodali su i:",
  "cart_checkout": "Naplata",
  "cart_empty": "Vaša košarica je prazna",
  "push_notifications": "Push obavijesti",
  "push_enabled": "Obavijesti omogućene",
  "push_disabled": "Omogući obavijesti",
  "blog_ai_generate": "AI generiranje",
  "blog_gen_service": "Generiraj za uslugu",
  "blog_generating": "Generiranje...",
  "export_revenue": "Izvještaj prihoda",
  "export_funnel": "Konverzijski ljevak",
  "export_users": "Popis korisnika",
  "export_pdf": "Sažetak",
  "license_generate": "Generiraj licencu",
  "license_revoke": "Opozovi",
  "license_renew": "Obnovi",
  "license_validate": "Provjeri",
  "tier_starter": "Starter",
  "tier_professional": "Profesionalni",
  "tier_enterprise": "Enterprise",
  "blog_subtitle": "Uvidi, novosti i vodiči od Infinity Businessa.",
  "blog_search_placeholder": "Pretražite članke...",
  "blog_all": "Sve",
  "blog_no_posts": "Nema pronađenih objava. Vratite se uskoro!",
  "blog_prev": "Prethodna",
  "blog_next": "Sljedeća",
  "blog_back": "Povratak na blog",
  "micro_tools": "Pametni mikro alati",
  "micro_tools_title": "Pametni mikro alati",
  "micro_tools_subtitle": "Besplatni AI mikro alati za vaše poslovanje",
  "color_palette_title": "Generator paleta boja",
  "color_palette_desc": "Generirajte lijepe palete boja za vaš brend",
  "color_palette_generate": "Generiraj paletu",
  "color_palette_copy": "Kopiraj",
  "color_palette_copied": "Kopirano!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Komplementarne",
  "color_palette_analogous": "Analogne",
  "color_palette_triadic": "Trijadne",
  "color_palette_monochromatic": "Monokromatske",
  "admin_menu_overview": "Pregled",
  "admin_menu_users": "Korisnici",
  "admin_menu_blog": "Upravitelj bloga",
  "admin_menu_analytics": "Analitika",
  "admin_menu_settings": "Postavke",
  "admin_menu_services": "Usluge",
  "admin_menu_chat": "Chat sesije",
  "admin_menu_notifications": "Obavijesti",
  "admin_menu_support": "Podrška",
  "admin_menu_security": "Sigurnost",
  "admin_menu_backup": "Sigurnosna kopija",
  "admin_menu_revenue": "Prihod",
  "admin_menu_funnel": "Lijevak",
  "admin_menu_invoicing": "Fakturiranje",
  "admin_menu_projects": "Projekti",
  "admin_menu_email": "E-mail editor",
  "admin_menu_ai_config": "AI konfiguracija",
  "admin_menu_live_analytics": "Analitika uživo",
  "admin_menu_platform_audit": "Revizija platforme",
  "docs_title": "Dokumentacija",
  "docs_subtitle": "Naučite koristiti našu platformu",
  "try_free_title": "Isprobajte besplatno",
  "try_free_subtitle": "Iskusite naše usluge besplatno",
  "subscription_title": "Planovi pretplate",
  "subscription_subtitle": "Odaberite plan koji vam odgovara",
  "portfolio_title": "Portfelj",
  "portfolio_subtitle": "Naš rad govori sam za sebe",
  "svc_web-dev_label": "Web razvoj",
  "svc_web-dev_desc": "Web stranice, landing stranice i web aplikacije",
  "svc_mobile-app_label": "Razvoj mobilnih aplikacija",
  "svc_mobile-app_desc": "iOS & Android aplikacije",
  "svc_graphic-design_label": "Grafički dizajn",
  "svc_graphic-design_desc": "Logotipi, brendiranje, marketinški materijali",
  "svc_custom-software_label": "Prilagođeni softver",
  "svc_custom-software_desc": "Prilagođena automatizacija i poslovni alati",
  "svc_ai-business-plan_label": "Pametni generator poslovnih planova",
  "svc_ai-business-plan_desc": "Potpuni poslovni plan s financijama i analizom tržišta",
  "svc_ai-seo-report_label": "Revizija web stranice i SEO izvještaj",
  "svc_ai-seo-report_desc": "Automatizirana analiza s preporukama",
  "svc_ai-email-campaign_label": "Postavljanje email marketinga",
  "svc_ai-email-campaign_desc": "AI piše tekstove i postavlja email sekvence",
  "svc_ai-competitor-analysis_label": "Izvještaj analize konkurencije",
  "svc_ai-competitor-analysis_desc": "Tržišna inteligencija i pozicioniranje",
  "svc_ai-legal-docs_label": "Generator pravnih dokumenata",
  "svc_ai-legal-docs_desc": "NDA, ugovori, uvjeti korištenja",
  "svc_crypto-education_label": "Kripto edukacija",
  "svc_crypto-education_desc": "Naučite blockchain, DeFi i kripto osnove",
  "svc_investment-tools_label": "Investicijski alati",
  "svc_investment-tools_desc": "Praćenje portfelja i analiza tržišta",
  "svc_defi-solutions_label": "DeFi rješenja",
  "svc_defi-solutions_desc": "Pametni ugovori, yield farming, likvidnosni bazeni",
  "svc_personal-advertising_label": "Osobni brending",
  "svc_personal-advertising_desc": "Izgradite svoju online prisutnost",
  "svc_ai-resume_label": "Pametni kreator životopisa",
  "svc_ai-resume_desc": "ATS-optimizirani životopisi",
  "svc_ai-brand-kit_label": "Pametni logo i brand kit",
  "svc_ai-brand-kit_desc": "Logo, paleta boja, tipografija i social assets",
  "svc_ai-social-calendar_label": "Kalendar društvenih mreža i analiza",
  "svc_ai-social-calendar_desc": "30 dana AI objava sa strategijom angažmana",
  "svc_ai-translation_label": "Pametna usluga prijevoda",
  "svc_ai-translation_desc": "Profesionalni prijevod dokumenata na 50+ jezika",
  "svc_ai-video-script_label": "Pametni pisac video skripti",
  "svc_ai-video-script_desc": "YouTube, TikTok i reklamne skripte",
  "admin_grp_dashboard": "Nadzorna ploča",
  "admin_grp_users": "Korisnici i pristup",
  "admin_grp_analytics": "Analitika i izvještaji",
  "admin_grp_services": "Usluge i cijene",
  "admin_grp_crypto": "Kripto i DeFi",
  "admin_grp_leads": "Potencijalni klijenti",
  "admin_grp_content": "Sadržaj",
  "admin_grp_comm": "Komunikacija",
  "admin_grp_social": "Društvene mreže",
  "admin_grp_ai": "AI i automatizacija",
  "admin_grp_design": "Dizajn i brending",
  "admin_grp_system": "Sustav",
  "admin_grp_projects": "Projekti i testiranje",
  "color_palette_professional": "Profesionalno",
  "color_palette_playful": "Razigrano",
  "color_palette_luxury": "Luksuzno",
  "color_palette_nature": "Priroda",
  "color_palette_tech": "Tehnologija",
  "color_palette_warm": "Toplo",
  "color_palette_cool": "Hladno",
  "blog_translating": "Prevođenje članka...",
  "blog_translated_cached": "Prevedeno",
  "blog_translated_fresh": "Upravo prevedeno",
  "blog_show_original": "Prikaži original",
  "privacy_s1_content": "Prikupljamo informacije koje nam izravno pružate, uključujući:\n- **Podaci o računu**: Ime, e-mail adresa i lozinka pri stvaranju računa.\n- **Zahtjevi za usluge**: Detalji projekta, proračun, rokovi i kontakt podaci.\n- **Podaci o plaćanju**: Podaci za naplatu obrađeni sigurno preko naših partnera (Stripe, myPOS).\n- **Komunikacijski podaci**: Poruke putem chata s RisTA-om, kontakt obrasci i e-mail korespondencija.\n- **Podaci o korištenju**: Vrsta preglednika, IP adresa, posjećene stranice i obrasci interakcije.",
  "privacy_s2_content": "Prikupljene informacije koristimo za:\n- Pružanje, održavanje i poboljšanje naših usluga\n- Obradu transakcija i slanje povezanih informacija\n- Slanje tehničkih obavijesti, ažuriranja i poruka podrške\n- Odgovaranje na vaše komentare, pitanja i zahtjeve\n- Praćenje i analizu trendova, korištenja i aktivnosti\n- Otkrivanje i sprječavanje prijevara\n- Personalizaciju vašeg iskustva s RisTA-om",
  "privacy_s3_content": "Ne prodajemo vaše osobne podatke. Možemo dijeliti informacije s:\n- **Davatelji usluga**: Tvrtke koje pružaju usluge u naše ime.\n- **Pravni zahtjevi**: Kada to zahtijeva zakon.\n- **Poslovni prijenosi**: U vezi s fuzijama ili prodajom.\n- **Pristanak**: Uz vaš izričiti pristanak.",
  "privacy_s4_content": "Provodimo standardne sigurnosne mjere:\n- Šifriranje podataka u prijenosu (TLS/SSL) i u mirovanju\n- Podrška za dvofaktorsku autentifikaciju (2FA)\n- Redovite sigurnosne revizije\n- Kontrole pristupa i autentifikacija\n- Sigurna obrada plaćanja putem PCI-usklađenih partnera",
  "privacy_s5_content": "Prema važećim zakonima o zaštiti podataka (uključujući GDPR), imate pravo na:\n- **Pristup**: Zatražite kopiju vaših osobnih podataka\n- **Ispravak**: Zatražite ispravak netočnih podataka\n- **Brisanje**: Zatražite brisanje vaših podataka\n- **Ograničenje**: Zatražite ograničenje obrade\n- **Prenosivost**: Zatražite prijenos u strojno čitljivom formatu\n- **Prigovor**: Uložite prigovor na obradu\n- **Povlačenje pristanka**: Povucite pristanak u bilo kojem trenutku\n\nKontaktirajte nas na privacy@infinitybusiness.org.",
  "privacy_s6_content": "Koristimo osnovne kolačiće za vašu sesiju i postavke. Možete upravljati postavkama kolačića putem preglednika.",
  "privacy_s7_content": "Vaše podatke čuvamo samo onoliko dugo koliko je potrebno za ispunjavanje svrha za koje su prikupljeni.",
  "privacy_s8_content": "Vaši podaci mogu biti preneseni u zemlje izvan EGP-a. Osiguravamo odgovarajuće zaštitne mjere.",
  "privacy_s9_content": "Možemo ažurirati ovu politiku privatnosti s vremena na vrijeme. Bitne promjene bit će objavljene na ovoj stranici.",
  "privacy_s10_content": "Za pitanja kontaktirajte:\n\n**Liber Nostra d.o.o.**\nE-mail: privacy@infinitybusiness.org\nWeb: infinitybusiness.org",
  "terms_s1_content": "Dobrodošli na Infinity Business (\"infinitybusiness.org\"), kojim upravlja **Liber Nostra d.o.o.**. Pristupanjem našoj platformi pristajete na ove Uvjete korištenja.",
  "terms_s2_content": "Infinity Business pruža digitalne usluge potpomognute AI-jem, uključujući:\n- Web razvoj, razvoj mobilnih aplikacija i grafički dizajn (B2B)\n- Poslovne i digitalne reklamne usluge\n- Kripto edukacija, investicijski alati i DeFi nadzorne ploče (P2P)\n- RisTA AI asistent (jednokratne i pretplatničke usluge)\n- Domene i web hosting",
  "terms_s3_content": "Za pristup određenim funkcijama morate stvoriti račun. Odgovorni ste za povjerljivost svojih podataka za prijavu.",
  "terms_s4_content": "Usluge mogu zahtijevati plaćanje. Plaćanja se obrađuju putem trećih strana (Stripe, PayPal, kriptovaluta). Pravila povrata:\n- **Jednokratne usluge**: Bez povrata nakon isporuke.\n- **Pretplate**: Moguće otkazati u bilo kojem trenutku.\n- **Prilagođeni projekti**: Prema individualnom dogovoru.",
  "terms_s5_content": "Naš AI asistent \"RisTA\" pruža automatiziranu pomoć i procjene troškova. Služe samo u informativne svrhe.",
  "terms_s6_content": "Sav sadržaj, dizajn, kod i materijali na ovoj platformi vlasništvo su tvrtke Liber Nostra d.o.o.",
  "terms_s7_content": "Vaše korištenje platforme također podliježe našim Pravilima privatnosti.",
  "terms_s8_content": "Sve usluge vezane uz kriptovalute služe samo u informativne svrhe. Ne pružamo financijske savjete.",
  "terms_s9_content": "Liber Nostra d.o.o. ne odgovara za neizravne, slučajne ili posljedične štete.",
  "terms_s10_content": "Zadržavamo pravo izmjene ovih Uvjeta u bilo kojem trenutku.",
  "terms_s11_content": "Ovi Uvjeti podliježu zakonima Republike Slovenije.",
  "terms_s12_content": "Za pitanja nas kontaktirajte ili pišite na support@infinitybusiness.org.",
  "admin_ad_generator": "Generator oglasa",
  "admin_add": "Dodaj",
  "admin_add_prompt": "Dodaj prompt",
  "admin_admin": "Administrator",
  "admin_advanced_reporting": "Napredno izvješćivanje",
  "admin_all": "Sve",
  "admin_analytics_dashboard": "Nadzorna ploča analitike",
  "admin_api_key": "API ključ",
  "admin_apply": "Primijeni",
  "admin_approved": "Odobreno",
  "admin_archive": "Arhiviraj",
  "admin_are_you_sure": "Jeste li sigurni?",
  "admin_audit_alerts": "Upozorenja revizije",
  "admin_author": "Autor",
  "admin_avg_session": "Prosj. sesija",
  "admin_back": "Natrag",
  "admin_badge": "Značka",
  "admin_balance": "Stanje",
  "admin_banned": "Blokiran",
  "admin_blog_manager": "Upravljanje blogom",
  "admin_body": "Sadržaj",
  "admin_bounce_rate": "Stopa napuštanja",
  "admin_browser": "Preglednik",
  "admin_campaign": "Kampanja",
  "admin_cannot_undo": "Ova radnja se ne može poništiti",
  "admin_category": "Kategorija",
  "admin_click_rate": "Stopa klikova",
  "admin_close": "Zatvori",
  "admin_completed": "Završeno",
  "admin_configuration": "Konfiguracija",
  "admin_confirm": "Potvrdi",
  "admin_contact_info": "Kontakt podaci",
  "admin_content": "Sadržaj",
  "admin_conversations": "Razgovori",
  "admin_conversion_funnel": "Konverzijski lijevak",
  "admin_conversion_rate": "Stopa konverzije",
  "admin_copied": "Kopirano u međuspremnik",
  "admin_copy": "Kopiraj",
  "admin_count": "Broj",
  "admin_country": "Država",
  "admin_create": "Kreiraj",
  "admin_create_experiment": "Kreiraj eksperiment",
  "admin_create_new": "Kreiraj novo",
  "admin_created_success": "Uspješno kreirano",
  "admin_credit_config": "Konfiguracija kredita",
  "admin_critical": "Kritično",
  "admin_custom": "Prilagođeno",
  "admin_daily": "Dnevno",
  "admin_date": "Datum",
  "admin_delete_failed": "Brisanje neuspješno",
  "admin_deleted_success": "Uspješno obrisano",
  "admin_demo_access": "Demo pristup",
  "admin_description": "Opis",
  "admin_deselect_all": "Odznači sve",
  "admin_details": "Detalji",
  "admin_device": "Uređaj",
  "admin_disable": "Onemogućiti",
  "admin_disabled": "Onemogućeno",
  "admin_doc_viewer": "Pregled dokumenata",
  "admin_documentation": "Dokumentacija",
  "admin_download": "Preuzmi",
  "admin_draft": "Skica",
  "admin_duplicate": "Dupliciraj",
  "admin_email": "E-mail",
  "admin_enable": "Omogućiti",
  "admin_enabled": "Omogućeno",
  "admin_end_date": "Završni datum",
  "admin_endpoint": "Krajnja točka",
  "admin_error": "Greška",
  "admin_escalation_queue": "Red eskalacija",
  "admin_event": "Događaj",
  "admin_events": "Događaji",
  "admin_experiment_name": "Naziv eksperimenta",
  "admin_export": "Izvoz",
  "admin_facebook_analytics": "Facebook analitika",
  "admin_false": "Netočno",
  "admin_filter": "Filtriraj",
  "admin_frequency": "Učestalost",
  "admin_generate": "Generiraj",
  "admin_headers": "Zaglavlja",
  "admin_health_monitoring": "Nadzor zdravlja",
  "admin_high": "Visoko",
  "admin_high_value_leads": "Visoko vrijedni leadovi",
  "admin_id": "ID",
  "admin_image": "Slika",
  "admin_import": "Uvoz",
  "admin_in_progress": "U tijeku",
  "admin_inactive": "Neaktivno",
  "admin_inbox": "Pristigla pošta",
  "admin_speed_audit": "Revizija brzine",
  "admin_info": "Info",
  "admin_ip_address": "IP adresa",
  "admin_joined": "Pridružio se",
  "admin_knowledge_base": "Baza znanja",
  "admin_language": "Jezik",
  "admin_last_activity": "Zadnja aktivnost",
  "admin_last_login": "Zadnja prijava",
  "admin_last_triggered": "Zadnji put pokrenuto",
  "admin_lead_score": "Ocjena leada",
  "admin_level": "Razina",
  "admin_load_failed": "Učitavanje neuspješno",
  "admin_loading_data": "Učitavanje podataka...",
  "admin_low": "Nisko",
  "admin_medium": "Srednje",
  "admin_messages": "Poruke",
  "admin_method": "Metoda",
  "admin_monetization": "Monetizacija",
  "admin_monthly": "Mjesečno",
  "admin_name": "Naziv",
  "admin_next": "Dalje",
  "admin_no": "Ne",
  "admin_no_data_available": "Nema dostupnih podataka",
  "admin_no_experiments": "Nema eksperimenata",
  "admin_no_leads": "Nema leadova",
  "admin_no_prompts": "Nema promptova",
  "admin_no_results": "Nema rezultata",
  "admin_no_results_found": "Nema pronađenih rezultata",
  "admin_none": "Ništa",
  "admin_off": "Isključeno",
  "admin_on": "Uključeno",
  "admin_open_rate": "Stopa otvaranja",
  "admin_page_views": "Pregledi stranica",
  "admin_partner_badges": "Partnerske značke",
  "admin_payload": "Sadržaj",
  "admin_payment_options": "Opcije plaćanja",
  "admin_platform": "Platforma",
  "admin_platform_audit": "Revizija platforme",
  "admin_points": "Bodovi",
  "admin_portfolio_manager": "Upravljanje portfoliom",
  "admin_preloader_config": "Konfiguracija preloadera",
  "admin_preview": "Pregled",
  "admin_previous": "Prethodno",
  "admin_price": "Cijena",
  "admin_priority": "Prioritet",
  "admin_prompt_name": "Naziv prompta",
  "admin_prompt_text": "Tekst prompta",
  "admin_published": "Objavljeno",
  "admin_recipients": "Primatelji",
  "admin_referral": "Preporuka",
  "admin_referral_leaderboard": "Ljestvica preporuka",
  "admin_refresh": "Osvježi",
  "admin_rejected": "Odbijeno",
  "admin_remove": "Ukloni",
  "admin_reset": "Resetiraj",
  "admin_response_time": "Vrijeme odgovora",
  "admin_restore": "Vrati",
  "admin_results": "Rezultati",
  "admin_retry": "Pokušaj ponovo",
  "admin_revenue_dashboard": "Nadzorna ploča prihoda",
  "admin_rista_services": "RisTA usluge",
  "admin_role": "Uloga",
  "admin_save_changes": "Spremi promjene",
  "admin_save_failed": "Spremanje neuspješno",
  "admin_saved_success": "Uspješno spremljeno",
  "admin_scheduled": "Zakazano",
  "admin_search": "Pretraži",
  "admin_select": "Odaberi",
  "admin_select_all": "Odaberi sve",
  "admin_send": "Pošalji",
  "admin_sent_success": "Uspješno poslano",
  "admin_server_resources": "Resursi poslužitelja",
  "admin_service_manager": "Upravljanje uslugama",
  "admin_session_duration": "Trajanje sesije",
  "admin_settings": "Postavke",
  "admin_slug": "Slug",
  "admin_social_automation": "Automatizacija društvenih mreža",
  "admin_something_wrong": "Nešto je pošlo po krivu",
  "admin_source": "Izvor",
  "admin_start_date": "Početni datum",
  "admin_subject": "Predmet",
  "admin_submit": "Pošalji",
  "admin_subscribers": "Pretplatnici",
  "admin_success": "Uspjeh",
  "admin_suspended": "Suspendiran",
  "admin_system_prompt": "Sistemski prompt",
  "admin_tags": "Oznake",
  "admin_template": "Predložak",
  "admin_templates": "Predlošci",
  "admin_test_results": "Rezultati testova",
  "admin_tester_program": "Program testera",
  "admin_title": "Naslov",
  "admin_total_revenue": "Ukupni prihod",
  "admin_total_sessions": "Ukupno sesija",
  "admin_total_users": "Ukupno korisnika",
  "admin_trigger": "Okidač",
  "admin_true": "Točno",
  "admin_try_again": "Molimo pokušajte ponovo",
  "admin_type": "Tip",
  "admin_unique_visitors": "Jedinstveni posjetitelji",
  "admin_unsubscribed": "Odjavljen",
  "admin_unverified": "Nepotvrđeno",
  "admin_update": "Ažuriraj",
  "admin_updated_success": "Uspješno ažurirano",
  "admin_upload": "Učitaj",
  "admin_urgent": "Hitno",
  "admin_user": "Korisnik",
  "admin_variant_a": "Varijanta A",
  "admin_variant_b": "Varijanta B",
  "admin_verified": "Potvrđeno",
  "admin_version": "Verzija",
  "admin_view": "Pregledaj",
  "admin_view_details": "Pogledaj detalje",
  "admin_viewer": "Gledatelj",
  "admin_warning": "Upozorenje",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Tjedno",
  "admin_yes": "Da",
  "admin_analytics_digest": "Sažetak analitike",
  "admin_blog_health": "Zdravlje bloga",
  "credit_title": "Krediti",
  "credit_subtitle": "Unaprijed plaćeni saldo za inteligentne usluge",
  "credit_available_balance": "Dostupni saldo",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Nadoplata",
  "credit_tab_history": "Povijest",
  "credit_tab_services": "Usluge",
  "credit_tab_crypto": "Kripto",
  "credit_balance_desc": "Vaš kredit može se koristiti za bilo koju AI uslugu:",
  "credit_bulk_discounts": "Popusti na količinu",
  "credit_add_credits": "Dodaj kredite",
  "credit_select_amount": "Odaberite iznos ili unesite prilagođenu vrijednost:",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "Dobit ćete",
  "credit_total_word": "ukupno",
  "credit_method_card": "Kartica",
  "credit_method_crypto": "Kripto",
  "credit_processing": "Obrada...",
  "credit_add_btn": "Dodaj",
  "credit_no_txn": "Nema transakcija",
  "credit_txn_topup": "Nadoplata",
  "credit_txn_promo": "Promo kredit",
  "credit_txn_auto": "Automatska kupnja",
  "credit_txn_purchase": "Kupnja",
  "credit_svc_intelligent": "Inteligentna usluga",
  "credit_svc_available": "Dostupno",
  "credit_svc_need_more": "Potrebno",
  "credit_svc_more": "više",
  "credit_crypto_send": "Pošalji",
  "credit_crypto_amount": "Iznos:",
  "credit_crypto_equivalent": "ekvivalent",
  "credit_crypto_network": "Mreža:",
  "credit_crypto_wallet": "Adresa novčanika",
  "credit_crypto_confirm": "Krediti će biti dodani nakon potvrde transakcije.",
  "credit_payment_id": "ID plaćanja:",
  "credit_crypto_back": "Natrag na odabir kriptovalute",
  "credit_crypto_select_title": "Odaberite kriptovalutu za nadoplatu",
  "credit_crypto_choose_desc": "Odaberite kovanicu. Dobit ćete adresu novčanika za plaćanje.",
  "credit_crypto_select_btn": "Odaberi",
  "credit_minimum": "Minimum €5",
  "credit_redirecting": "Preusmjeravanje...",
  "credit_topup_failed": "Nadoplata neuspjela",
  "credit_crypto_failed": "Neuspjelo pokretanje kripto plaćanja",
  "cart_title": "Košarica",
  "cart_total": "Ukupno",
  "cart_stripe_checkout": "Stripe plaćanje",
  "cart_credits": "Krediti",
  "cart_secure_stripe": "Sigurno Stripe plaćanje",
  "cart_insufficient": "Nedovoljno kredita. Prvo nadoplatite ili odaberite plaćanje karticom.",
  "cart_pay_card": "Plati karticom",
  "cart_pay_credits_btn": "Plati kreditima",
  "cart_clear": "Isprazni košaricu",
  "cart_processing": "Obrada...",
  "cart_payment_success": "Plaćanje uspješno! Vaša narudžba se obrađuje.",
  "cart_complete_setup": "Dovršite postavke",
  "cart_also_added": "Klijenti koji su kupili slične usluge također su dodali:",
  "cart_add": "Dodaj",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Preostali saldo:",
  "cart_checkout_failed": "Plaćanje neuspjelo",
  "cart_checkout_no_session": "Nije moguće kreirati sesiju plaćanja",
  "cart_purchased": "Kupljeno",
  "cart_services_with_credits": "usluga(-e) kreditima!",
  "credits_balance_title": "Saldo kredita",
  "credits_topup_btn": "Nadoplati kredite",
  "credits_rate": "1 EUR = 1 Kredit",
  "credits_total_topup": "Ukupno nadoplaćeno",
  "credits_spent_credits": "Potrošeno (Krediti)",
  "credits_spent_payments": "Potrošeno (Plaćanja)",
  "credits_txn_history": "Povijest transakcija",
  "credits_no_txn": "Nema transakcija",
  "credits_txn_topup": "Nadoplata",
  "credits_txn_promo": "Promo kredit",
  "credits_txn_purchase": "Kupnja usluge",
  "credits_txn_ai": "AI usluga",
  "credits_order_history": "Povijest narudžbi",
  "credits_order_label": "Narudžba:",
  "chat_translate_btn": "Prevedi na engleski",
  "chat_translating": "Prevođenje...",
  "chat_translated_label": "Prikazuje se engleski prijevod. Kliknite \"Prikaži original\" za originalne poruke.",
  "chat_show_original": "Prikaži original",
  "chat_show_translated": "Prikaži prijevod",
  "pkg_section_badge": "Ponude s ograničenim vremenom",
  "pkg_section_title": "Pokrenite svoj posao",
  "pkg_section_title_highlight": "Danas",
  "pkg_section_subtitle": "Premium paketi dizajnirani da vas brzo dovedu online — s inteligentnom tehnologijom ugrađenom od prvog dana.",
  "pkg_section_footer": "Sve cijene isključuju PDV gdje je primjenjivo. Niste sigurni koji paket odgovara? Razgovarajte s RisTA za besplatnu konzultaciju.",
  "pkg_cta_default": "Započni",
  "admin_package_mgr": "Upravitelj paketa",
  "admin_pkg_title": "Paketi odredišne stranice",
  "admin_pkg_subtitle": "Upravljajte istaknutim paketima cijena prikazanim na odredišnoj stranici",
  "admin_pkg_seed": "Zadane vrijednosti sjemena",
  "admin_pkg_new": "Novi paket",
  "admin_pkg_create_title": "Kreiraj novi paket",
  "admin_pkg_edit_title": "Uredi paket",
  "admin_pkg_name": "Ime paketa",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Opis",
  "admin_pkg_price": "Cijena",
  "admin_pkg_currency": "Valuta",
  "admin_pkg_price_note": "Napomena o cijeni",
  "admin_pkg_badge": "Odlikovanje",
  "admin_pkg_accent": "Naglasna boja",
  "admin_pkg_cta_text": "Tekst gumba CTA",
  "admin_pkg_cta_link": "CTA poveznica (neobavezno)",
  "admin_pkg_sort": "Redoslijed sortiranja",
  "admin_pkg_features": "Značajke / Usluge uključene",
  "admin_pkg_add_feature": "Dodaj značajku",
  "admin_pkg_highlighted": "Istaknuto",
  "admin_pkg_normal": "Normalno",
  "admin_pkg_create": "Kreiraj paket",
  "admin_pkg_save": "Spremi promjene",
  "admin_pkg_saving": "Spremam...",
  "admin_pkg_cancel": "Otkaži",
  "admin_pkg_empty_title": "Još uvijek nije konfigurirano nijedan paket",
  "admin_pkg_empty_desc": "Kliknite na Zadane vrijednosti sjemena kako biste generirali dva početna paketa ili kreirajte svoj vlastiti.",
  "admin_pkg_features_label": "značajke",
  "admin_pkg_sort_label": "Sortiraj",
  "admin_pkg_delete_confirm": "Izbrisati ovaj paket? Bit će uklonjen s odredišne stranice.",
  "admin_pkg_feature_placeholder": "Opis značajke...",
  "admin_pkg_pricenote_placeholder": "npr. Jednokratno / +5% udjela u prihodu",
  "admin_pkg_badge_placeholder": "npr. NAJBOLJA VRIJEDNOST",
  "admin_pkg_loading": "Učitavanje paketa...",
  "pkg_qa_have_domain": "Da, imam domenu",
  "pkg_qa_need_domain": "Trebam domenu",
  "pkg_qa_describe_biz": "Dopustite da opišem svoje poslovanje",
  "pkg_qa_more_info": "Recite mi više o ovom paketu",
  "sp_managed_hosting": "Upravljani hosting",
  "sp_managed_hosting_desc": "Potpuno upravljani hosting s nadzorom i podrškom.",
  "sp_enterprise_ad": "Enterprise oglašavanje",
  "sp_enterprise_ad_desc": "Velike reklamne kampanje s posvećenom strategijom.",
  "sp_email_marketing": "Email marketing postavljanje",
  "sp_email_marketing_desc": "Profesionalne email sekvence i automatizacija marketinga.",
  "sp_competitor_analysis": "Izvještaj o konkurenciji",
  "sp_competitor_analysis_desc": "Tržišna inteligencija i konkurentsko pozicioniranje.",
  "sp_website_audit": "Revizija web stranice i SEO izvještaj",
  "sp_website_audit_desc": "Sveobuhvatna analiza stranice s preporukama.",
  "sp_managed_trading": "Upravljano trgovanje",
  "sp_managed_trading_desc": "Stručno upravljano trgovanje s dokazanim strategijama.",
  "sp_trading_consult": "Konzultacije za trgovanje",
  "sp_trading_consult_desc": "Individualne sesije strategije trgovanja.",
  "sp_domains": "LiveDomain tržište",
  "sp_domains_desc": "Premium akvizicija domena i aftermarket ponude.",
  "sp_domain_mgmt": "Upravljanje domenama",
  "sp_domain_mgmt_desc": "DNS upravljanje, obnove i transferi.",
  "sp_defi": "DeFi rješenja",
  "sp_defi_desc": "Pametni ugovori, yield farming i likvidnosni poolovi.",
  "sp_personal_brand": "Osobni branding",
  "sp_personal_brand_desc": "Izgradite svoju online prisutnost i osobni brand.",
  "sp_ad_gen": "Generator oglasa",
  "sp_ad_gen_desc": "Odmah generirajte konvertirajuće reklamne tekstove.",
  "sp_priority": "Prioritetni red",
  "sp_priority_desc": "Garantirani odgovor unutar 4 sata.",
  "sp_maintenance": "Plan održavanja",
  "sp_maintenance_desc": "Tekuće održavanje, ažuriranja i tehnička podrška.",
  "sp_consulting": "Pametna konzultacija",
  "sp_consulting_desc": "Individualna konzultacija s našim stručnjacima.",
  "sp_market_snapshot": "Pregled tržišta",
  "sp_market_snapshot_desc": "Brzi pregled tržišnog krajolika i trendova.",
  "sp_trend_explainer": "Objašnjenje trendova",
  "sp_trend_explainer_desc": "Razumijevanje novih trendova u vašoj industriji.",
  "sp_competitor_qa": "Pitanja o konkurenciji",
  "sp_competitor_qa_desc": "Odgovori o strategijama vaših konkurenata.",
  "sp_country_entry": "Provjera ulaska na tržište",
  "sp_country_entry_desc": "Procjena spremnosti za međunarodnu ekspanziju.",
  "sp_vendor_shortlist": "Popis dobavljača",
  "sp_vendor_shortlist_desc": "Kurirani popis dobavljača za vaše potrebe.",
  "sp_tam_logic": "TAM logička skica",
  "sp_tam_logic_desc": "Procjena ukupnog tržišta s logičkom razradom.",
  "sp_positioning": "Analiza pozicioniranja",
  "sp_positioning_desc": "Strategija pozicioniranja proizvoda i publike.",
  "sp_addon_title": "Dodaci i podrška",
  "sp_addon_desc": "Pojačajte projekt s prioritetnom podrškom i stručnim konzultacijama.",
  "sp_research_title": "Pametni istraživački proizvodi",
  "sp_research_desc": "Tržišna inteligencija i alati za istraživanje na zahtjev.",
  "tier_section_badge": "Pametni paketi",
  "tier_section_title": "Odaberite svoj",
  "tier_section_highlight": "Plan rasta",
  "tier_section_subtitle": "Paketi dizajnirani za maksimalnu vrijednost. Odaberite razinu koja vam odgovara.",
  "tier_one_time": "Jednokratno",
  "tier_monthly": "Mjesečno",
  "tier_section_footer": "Sve cijene su bez PDV-a. Trebate prilagođeni paket? Razgovarajte s RisTA-om.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Savršeno za početak vaše digitalne prisutnosti",
  "tier_tag_growth": "Skalirajte poslovanje pametnim alatima i marketingom",
  "tier_tag_pro": "Kompletni digitalni rast za ozbiljne tvrtke",
  "tier_tag_enterprise": "Potpuna digitalna transformacija vašeg poslovanja",
  "tier_cta_starter": "Odaberi Starter",
  "tier_cta_growth": "Odaberi Growth",
  "tier_cta_pro": "Odaberi Pro",
  "tier_cta_enterprise": "Odaberi Enterprise",
  "tier_badge_popular": "POPULARNO",
  "tier_badge_best": "NAJBOLJA VRIJEDNOST",
  "tier_badge_all": "SVE U JEDNOM",
  "tier_per_mo": "mj.",
  "tier_once_label": "jednokratno",
  "tier_or_monthly": "ili",
  "tier_f_starter_1": "Pametni generator poslovnog plana",
  "tier_f_starter_2": "Pametni builder životopisa (3 kom.)",
  "tier_f_starter_3": "Revizija stranice i SEO izvještaj",
  "tier_f_starter_4": "Pametni logo i brand kit",
  "tier_f_starter_5": "Izvještaj pregleda tržišta",
  "tier_f_starter_6": "Nacrt FAQ odgovora",
  "tier_f_starter_7": "Nacrt bloga iz trenda",
  "tier_f_starter_8": "Email podrška unutar 48h",
  "tier_f_growth_1": "Sve iz Startera",
  "tier_f_growth_2": "Pametna email kampanja",
  "tier_f_growth_3": "Kalendar i analiza društvenih mreža (3 mj.)",
  "tier_f_growth_4": "Izvještaj analize konkurencije",
  "tier_f_growth_5": "Generator oglasa (5 kampanja)",
  "tier_f_growth_6": "Generator outreach emailova",
  "tier_f_growth_7": "Objašnjenje trendova",
  "tier_f_growth_8": "Analiza pozicioniranja",
  "tier_f_growth_9": "Prioritetna email podrška unutar 24h",
  "tier_f_pro_1": "Sve iz Growtha",
  "tier_f_pro_2": "SEO i digitalni marketing setup",
  "tier_f_pro_3": "Email marketing setup",
  "tier_f_pro_4": "Pametni pisac video skripti (5 kom.)",
  "tier_f_pro_5": "Brza TAM logička skica",
  "tier_f_pro_6": "Kontrolna lista rizika",
  "tier_f_pro_7": "Prioritizacija značajki",
  "tier_f_pro_8": "Nacrt popisa dobavljača",
  "tier_f_pro_9": "Pametna konzultacija (2 sata)",
  "tier_f_pro_10": "Prioritetna podrška unutar 12h",
  "tier_f_ent_1": "Sve iz Pro",
  "tier_f_ent_2": "Razvoj prilagođenog softvera",
  "tier_f_ent_3": "Enterprise strategija oglašavanja",
  "tier_f_ent_4": "Upravljani hosting (12 mjeseci)",
  "tier_f_ent_5": "Plan održavanja (6 mjeseci)",
  "tier_f_ent_6": "Pametna konzultacija (10 sati)",
  "tier_f_ent_7": "Provjera ulaska na tržište",
  "tier_f_ent_8": "Izvršni sažetak za prezentacije",
  "tier_f_ent_9": "JTBD izjava problema",
  "tier_f_ent_10": "Posvećeni account menadžer",
  "tier_f_ent_11": "Prioritetni red (odgovor 4h)",
  "calc_title": "Kalkulator cijena",
  "calc_subtitle": "Usporedite pojedinačne usluge s paketima.",
  "calc_badge": "Uštedite više",
  "calc_select_services": "Odaberite usluge",
  "calc_search_placeholder": "Pretražite usluge...",
  "calc_selected": "odabrano",
  "calc_your_selection": "Vaš odabir",
  "calc_individual_total": "Pojedinačni ukupno",
  "calc_best_tier": "Najbolji odgovarajući paket",
  "calc_you_save": "Uštedite",
  "calc_no_services": "Odaberite usluge za prikaz ušteda",
  "calc_clear_all": "Očisti sve",
  "calc_get_tier": "Nabavi ovaj paket",
  "calc_individual_cheaper": "Pojedinačne usluge su već isplative. Dodajte još za otključavanje paketa!",
  "referred_by": "Preporuka od",
  "referral_signup_reward": "Registrirajte se kako biste povezali svoj račun s ovom preporukom.",
  "badge_coming_soon": "Uskoro dostupno",
  "badge_available_soon": "Dostupno uskoro",
  "badge_from_price": "od",
  "badge_preparing": "Pripremamo ovu uslugu za vas",
  "svc_managed-hosting_label": "Upravljani hosting",
  "svc_managed-hosting_desc": "Potpuno upravljani hosting s nadzorom i podrškom",
  "svc_enterprise-advertising_label": "Korporativno oglašavanje",
  "svc_enterprise-advertising_desc": "Velike reklamne kampanje s posvećenom strategijom",
  "svc_email-marketing_label": "Postavljanje email marketinga",
  "svc_email-marketing_desc": "Profesionalni email nizovi, predlošci i automatizacija",
  "svc_competitor-analysis_label": "Izvješće o analizi konkurencije",
  "svc_competitor-analysis_desc": "Tržišna inteligencija i konkurentsko pozicioniranje",
  "svc_legal-docs_label": "Generator pravnih dokumenata",
  "svc_legal-docs_desc": "NDA, ugovori, predlošci uvjeta korištenja",
  "svc_website-audit_label": "Web revizija i SEO izvješće",
  "svc_website-audit_desc": "Sveobuhvatna analiza stranice s preporukama",
  "svc_trading-consultation_label": "Konzultacije o trgovanju",
  "svc_trading-consultation_desc": "Stručno vođene sesije strategije trgovanja",
  "svc_managed-trading_label": "Upravljano trgovanje",
  "svc_managed-trading_desc": "Stručno upravljano trgovanje s provjerenim strategijama",
  "svc_domain-management_label": "Upravljanje domenama",
  "svc_domain-management_desc": "Registracija domena, DNS upravljanje i transferi",
  "svc_personal-branding_label": "Osobni branding",
  "svc_personal-branding_desc": "Izgradite svoju online prisutnost i osobni brand",
  "admin_escalation_alert": "Eskalacija razgovora",
  "admin_view_escalations": "Pogledaj red eskalacija",
  "from": "Od",
  "vector_gen_title": "Pametni vektorski",
  "vector_gen_title_hl": "Generator",
  "vector_gen_badge": "Pametni vektorski studio",
  "vector_gen_desc": "Opišite svoju ideju, učitajte reference i dobijte SVG vektorsku grafiku spremnu za proizvodnju u nekoliko sekundi.",
  "vector_gen_balance": "Vaš saldo",
  "vector_gen_per_gen": "kredita po generiranju",
  "vector_gen_prompt_label": "Opišite svoju vektorsku grafiku",
  "vector_gen_prompt_ph": "npr. Minimalistički logo planine sa sunčevim zrakama, koristeći teal i narančaste boje...",
  "vector_gen_style": "Stil",
  "vector_gen_color": "Način boja",
  "vector_gen_refs": "Referentne datoteke",
  "vector_gen_optional": "opcionalno, maks. 3",
  "vector_gen_upload": "Učitaj referencu (PNG, JPG, SVG)",
  "vector_gen_generating": "Generiranje...",
  "vector_gen_cta": "Generiraj vektor",
  "vector_gen_result": "Vaša vektorska grafika",
  "vector_gen_model_used": "Model",
  "vector_gen_history": "Povijest generiranja",
  "vector_gen_no_history": "Još nema generiranja",
  "vector_gen_login_req": "Prijavite se za korištenje vektorskog generatora.",
  "vector_gen_service_title": "Trebate profesionalne vektore?",
  "vector_gen_service_desc": "Naručite prilagođene vektorske grafike kao potpunu uslugu dizajna s revizijama i smjernicama brenda.",
  "vector_gen_service_cta": "Pogledajte dizajn usluge",
  "vector_gen_product_type": "Vrsta proizvoda",
  "vector_gen_size": "Veličina izlaza",
  "vector_gen_error_prompt": "Opišite svoju ideju za vektorsku grafiku.",
  "admin_vector_gen": "Vektorski generator",
  "admin_showroom": "Izlog",
  "admin_landing_page": "Odredišna stranica",
  "admin_landing_text": "Tekstovi odredišne stranice",
  "admin_vector_title": "Vektorski generator",
  "admin_vector_models": "Dostupni modeli",
  "admin_vector_pricing": "Cijene i ograničenja",
  "svc_vector-generator_label": "Pametni vektorski generator",
  "svc_vector-generator_desc": "Generirajte SVG vektorske grafike spremne za proizvodnju iz tekstualnih opisa",
  "sp_vector_gen_name": "Pametni vektorski generator",
  "sp_vector_gen_desc": "Generirajte SVG vektorske grafike iz tekstualnih opisa pomoću pametne tehnologije.",
  "sp_vector_gen_feat": "Tekst-u-vektor generiranje|SVG i PNG izvoz|Više stilskih predložaka|Inline SVG editor|Upload referentnih datoteka|Cijene temeljene na kreditima",
  "sp_managed_hosting_name": "Upravljani hosting",
  "sp_managed_hosting_feat": "24/7 nadzor|Automatska ažuriranja|SSL upravljanje|Dnevne sigurnosne kopije|Optimizacija performansi|Posvećena podrška",
  "sp_enterprise_ad_name": "Korporativno oglašavanje",
  "sp_enterprise_ad_feat": "Strategija kampanje|Multi-kanal|A/B testiranje|Praćenje performansi|Posvećeni upravitelj|Izvještaji",
  "sp_email_marketing_name": "Email marketing postavljanje",
  "sp_email_marketing_feat": "Email sekvence|Dizajn predložaka|Automatizacija|Upravljanje listama|Analitika|A/B testiranje",
  "sp_competitor_analysis_name": "Izvješće o analizi konkurencije",
  "sp_competitor_analysis_feat": "Analiza tržišta|Profili konkurenata|SWOT|Usporedba cijena|Preporuke|Ažuriranja",
  "sp_website_audit_name": "Revizija web stranice i SEO izvješće",
  "sp_website_audit_feat": "Tehnička revizija|SEO analiza|Metriki performansi|Pristupačnost|Sigurnosno skeniranje|Plan akcije",
  "sp_defi_name": "DeFi rješenja",
  "sp_defi_feat": "Pametni ugovori|Yield farming|Likvidnosni bazeni|DeFi revizija|Kreiranje tokena|Staking rješenja",
  "sp_personal_brand_name": "Osobni brending",
  "sp_personal_brand_feat": "Strategija brenda|Prisutnost na društvenim mrežama|Osobna web stranica|Planiranje sadržaja|Profesionalne fotografije|Pisanje biografije",
  "sp_ad_gen_name": "Generator oglasa",
  "sp_ad_gen_feat": "Oglasni tekstovi|Kreativni formati|Više platformi|A/B varijante|Ciljanje publike|Savjeti za performanse",
  "sp_priority_name": "Prioritetni red",
  "sp_priority_feat": "Odgovor u 4 sata|Posvećeni kanal|Prioritetna obrada|Ažuriranja statusa|SLA garancija|Proširena podrška",
  "sp_maintenance_name": "Plan održavanja",
  "sp_maintenance_feat": "Mjesečna ažuriranja|Sigurnosne zakrpe|Praćenje performansi|Popravci grešaka|Garancija dostupnosti|Prioritetna podrška",
  "sp_consulting_name": "Pametna konzultacijska sesija",
  "sp_consulting_feat": "Stručno savjetovanje|Strateška sesija|Tehnički savjeti|Plan implementacije|Bilješke nakon sesije|Snimka uključena",
  "sp_market_snapshot_name": "Pregled tržišta",
  "sp_market_snapshot_feat": "Pregled tržišta|Ključni trendovi|Konkurentsko okruženje|Prilike za rast|Čimbenici rizika|Izvršni sažetak",
  "sp_trend_explainer_name": "Objašnjenje trendova",
  "sp_trend_explainer_feat": "Analiza trendova|Utjecaj na industriju|Procjena prilika|Projekcija vremena|Koraci djelovanja|Vizualni izvještaj",
  "sp_competitor_qa_name": "Pitanja o konkurenciji",
  "sp_competitor_qa_feat": "Analiza strategije|Uvid u cijene|Tržišno pozicioniranje|Usporedba značajki|Analiza slabosti|Mapa prilika",
  "sp_country_entry_name": "Provjera ulaska na tržište",
  "sp_country_entry_feat": "Spremnost tržišta|Regulatorni pregled|Kulturni čimbenici|Analiza konkurencije|Strategija ulaska|Procjena rizika",
  "sp_vendor_shortlist_name": "Kratka lista dobavljača",
  "sp_vendor_shortlist_feat": "Istraživanje dobavljača|Matrica usporedbe|Analiza cijena|Procjena sposobnosti|Preporuke|Kontakt podaci",
  "sp_tam_logic_name": "Skica TAM logike",
  "sp_tam_logic_feat": "TAM procjena|SAM/SOM razrada|Logički okvir|Izvori podataka|Pretpostavke rasta|Vizualna prezentacija",
  "sp_positioning_name": "Strategija pozicioniranja",
  "sp_positioning_feat": "Tržišno pozicioniranje|Segmentacija publike|Ponuda vrijednosti|Okvir poruka|Diferencijacija|Konkurentska prednost",
  "sp_managed_trading_name": "Upravljano trgovanje",
  "sp_managed_trading_feat": "Upravljanje portfeljom|Upravljanje rizicima|Provjerene strategije|Redoviti izvještaji|Posvećeni upravitelj|Analiza tržišta",
  "sp_trading_consult_name": "Konzultacije o trgovanju",
  "sp_trading_consult_feat": "Individualne sesije|Razvoj strategije|Analiza tržišta|Procjena rizika|Pregled portfelja|Stručno vodstvo",
  "sp_domains_name": "LiveDomain tržište",
  "sp_domains_feat": "Premium domene|Aftermarket ponude|Procjena domene|Podrška za transfer|Pregovaranje|Upravljanje portfeljom",
  "sp_domain_mgmt_name": "Upravljanje domenama",
  "sp_domain_mgmt_feat": "DNS upravljanje|Automatsko obnavljanje|Podrška za transfer|Praćenje portfelja|SSL certifikati|Whois privatnost",
  "vector_gen_model": "Model",
  "vector_gen_quality": "Razina kvalitete",
  "svc_smart-resume_label": "Pametni kreator životopisa",
  "svc_smart-resume_desc": "ATS-optimizirani životopisi izrađeni našim pametnim sustavom",
  "svc_smart-business-plan_label": "Pametni generator poslovnog plana",
  "svc_smart-business-plan_desc": "Potpuni poslovni plan s financijama i analizom tržišta",
  "svc_smart-seo-report_label": "Pametno SEO izvješće",
  "svc_smart-seo-report_desc": "Automatizirana analiza web stranice s preporukama",
  "svc_smart-brand-kit_label": "Pametni logo i brend paket",
  "svc_smart-brand-kit_desc": "Koncept logotipa, paleta boja, tipografija i materijali za društvene mreže",
  "svc_smart-email-campaign_label": "Pametna email kampanja",
  "svc_smart-email-campaign_desc": "Inteligentni email marketing s optimiziranim sekvencama",
  "svc_smart-social-calendar_label": "Kalendar i analiza društvenih mreža",
  "svc_smart-social-calendar_desc": "30 dana pametno generiranih objava sa strategijom angažmana",
  "svc_ad-generator_label": "Generator oglasa",
  "svc_ad-generator_desc": "Trenutačno generirajte visoko konvertirajuće oglasne tekstove",
  "svc_smart-translation_label": "Pametne usluge prevođenja",
  "svc_smart-translation_desc": "Profesionalno prevođenje dokumenata na 50+ jezika",
  "svc_smart-video-script_label": "Pametni pisac video scenarija",
  "svc_smart-video-script_desc": "YouTube, TikTok i oglasni scenariji optimizirani za angažman",
  "svc_priority-queue_label": "Prioritetni red",
  "svc_priority-queue_desc": "Garantirani odgovor unutar 4 sata",
  "svc_maintenance-plan_label": "Plan održavanja",
  "svc_maintenance-plan_desc": "Tekuće održavanje, ažuriranja i tehnička podrška",
  "svc_smart-consulting_label": "Pametna konzultacijska sesija",
  "svc_smart-consulting_desc": "Individualno savjetovanje s našim tehnološkim stručnjacima",
  "svc_market-snapshot_label": "Pregled tržišta",
  "svc_market-snapshot_desc": "Brzi pregled vašeg tržišnog okruženja",
  "svc_trend-explainer_label": "Objašnjenje trendova",
  "svc_trend-explainer_desc": "Razumijte nove trendove relevantne za vašu industriju",
  "svc_competitor-qa_label": "Pitanja o konkurenciji",
  "svc_competitor-qa_desc": "Dobijte odgovore o strategijama vaših konkurenata",
  "svc_country-entry-check_label": "Provjera ulaska na tržište",
  "svc_country-entry-check_desc": "Ocjena spremnosti tržišta za međunarodnu ekspanziju",
  "svc_should-i-care_label": "Provjera relevantnosti",
  "svc_should-i-care_desc": "Procijenite je li trend važan za vaše poslovanje",
  "svc_report-matchmaker_label": "Pronalazač izvještaja",
  "svc_report-matchmaker_desc": "Pronađite pravi istraživački izvještaj",
  "svc_which-region-first_label": "Prioritet regija",
  "svc_which-region-first_desc": "Preporuke temeljene na podacima za ulazak na regionalno tržište",
  "svc_vendor-shortlist_label": "Kratka lista dobavljača",
  "svc_vendor-shortlist_desc": "Kurirana lista dobavljača za vaše potrebe",
  "svc_forecast-explanation_label": "Objašnjenje prognoze",
  "svc_forecast-explanation_desc": "Jasno objašnjenje tržišnih prognoza",
  "svc_outreach-email-gen_label": "Generator kontaktnih emailova",
  "svc_outreach-email-gen_desc": "Generirajte personalizirane kontaktne emailove",
  "svc_executive-summary_label": "Izvršni sažetak",
  "svc_executive-summary_desc": "Sažeci spremni za prezentacije",
  "svc_faq-answer-draft_label": "Nacrt FAQ odgovora",
  "svc_faq-answer-draft_desc": "Izradite odgovore na najčešća pitanja kupaca",
  "svc_jtbd-problem_label": "JTBD izjava o problemu",
  "svc_jtbd-problem_desc": "Analiza problema prema JTBD okviru",
  "svc_tam-logic-sketch_label": "Skica TAM logike",
  "svc_tam-logic-sketch_desc": "Procjena ukupnog adresabilnog tržišta s logičkom razradom",
  "svc_risk-checklist_label": "Kontrolna lista rizika",
  "svc_risk-checklist_desc": "Sveobuhvatna kontrolna lista za procjenu rizika",
  "svc_feature-prioritization_label": "Prioritizacija značajki",
  "svc_feature-prioritization_desc": "Preporuke za prioritizaciju značajki temeljene na podacima",
  "svc_next-research-question_label": "Sljedeće istraživačko pitanje",
  "svc_next-research-question_desc": "Otkrijte sljedeće ključno istraživačko pitanje",
  "svc_positioning-angle_label": "Strategija pozicioniranja",
  "svc_positioning-angle_desc": "Analiza pozicioniranja proizvoda i ciljne skupine",
  "svc_blog-outline-trend_label": "Blog nacrt iz trenda",
  "svc_blog-outline-trend_desc": "Pretvorite trending teme u strukturirane blog nacrte",
  "admin_ai_reports": "Izvještaji AI usluga",
  "admin_project_delivery": "Isporuka projekta",
  "admin_analytics_digest": "Sažetak analitike",
  "admin_seo_suggestions": "SEO optimizacija",
  "admin_visitor_map": "Mapa posjetitelja",
  "admin_competitor_monitor": "Konkurentska inteligencija",
  "admin_email_workflows": "Email tokovi rada",
  "admin_collab_editing": "Timska suradnja",
  "admin_status_online": "Na mreži",
  "admin_status_offline": "Izvan mreže",
  "admin_status_online_desc": "Vidljivi ste kao dostupni. Korisnici koji traže eskalaciju bit će povezani s vama.",
  "admin_status_offline_desc": "Izvan ste mreže. Korisnici koji traže eskalaciju vidjet će poruku da pokušaju kasnije.",
  "admin_ai_model": "AI model",
  "admin_prompts": "Upiti",
  "admin_no_escalations": "Nema eskalacija u redu čekanja.",
  "blog_edit": "Uredi objavu",
  "admin_card_visibility": "Vidljivost kartica",
  "agency_rista_tooltip": "Razgovaraj s RisTA",
  "agency_hero_title_1": "Munjevito brze web stranice koje ",
  "agency_hero_title_highlight": "prodaju",
  "agency_hero_title_2": " za lokalne tvrtke",
  "agency_hero_subtitle_1": "Dobijte prilagođenu stranicu koja se učitava u milisekundama + ugrađena analitika za",
  "agency_hero_subtitle_2": ". Bez sporih stranica, više leadova — pokretanje za tjedne.",
  "agency_hero_limited": "Ograničen broj mjesta!",
  "agency_hero_cta_pricing": "Pogledaj paket od €498",
  "agency_hero_cta_audit": "Besplatna revizija",
  "agency_trust_maintenance": "održavanje nakon",
  "agency_trust_efficient": "100% Učinkovito",
  "agency_trust_powered": "Pokreće Inteligentni Sustav",
  "agency_speed_title": "Brzina učitavanja web stranice",
  "agency_speed_before": "Prije",
  "agency_speed_after": "Poslije",
  "agency_speed_leads": "+35% leadova",
  "agency_pain_title_1": "Spore web stranice ",
  "agency_pain_title_2": "ubijaju prodaju",
  "agency_pain_subtitle": "Svaka sekunda koju vaša stranica treba za učitavanje, gubite kupce. Evo problema — i kako ga rješavamo.",
  "agency_pain_slow_title": "Sporo učitavanje = Izgubljeni leadovi",
  "agency_pain_slow_desc": "Vaša web stranica treba 5+ sekundi za učitavanje. Posjetitelji odlaze prije nego što vide vašu ponudu. Plaćate promet koji nikada ne konvertira.",
  "agency_pain_stats_title": "47% odlazi ako >3s",
  "agency_pain_stats_desc": "Google istraživanje pokazuje da gotovo polovica posjetitelja napušta mobilnu stranicu koja se učitava duže od 3 sekunde.",
  "agency_pain_stats_source": "Izvor: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Naša Speed-First tehnologija",
  "agency_pain_solution_desc": "Prilagođene stranice optimizirane za učitavanje ispod 1 sekunde. Edge-cache, optimizirane slike, minimizirani kod. Više brzine = više leadova = više prihoda.",
  "agency_pricing_title": "Jednostavne, transparentne cijene",
  "agency_pricing_subtitle": "Odaberite plan koji odgovara vašem poslovanju. Svi planovi uključuju našu Speed-First tehnologiju.",
  "agency_pricing_urgency_1": "Samo još ",
  "agency_pricing_urgency_2": " starter mjesta ovaj mjesec",
  "agency_pricing_popular": "NAJPOPULARNIJE",
  "agency_pricing_get_started": "Započnite",
  "agency_pricing_guarantee": "30-dnevna garancija povrata novca",
  "agency_pricing_ideal": "Idealno za:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "jednokratno",
  "agency_pricing_starter_ideal": "Poduzetnike pojedince",
  "agency_pricing_s_1": "Munjevito brza prilagođena web stranica",
  "agency_pricing_s_2": "Domena + hosting za 1 godinu",
  "agency_pricing_s_3": "Osnovna analitička ploča",
  "agency_pricing_s_4": "Mobilno prilagođeni dizajn",
  "agency_pricing_s_5": "SSL certifikat uključen",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Rastuće trgovine",
  "agency_pricing_p_1": "Sve iz Starter paketa",
  "agency_pricing_p_2": "E-trgovina + oporavak košarice",
  "agency_pricing_p_3": "SEO optimizacijski paket",
  "agency_pricing_p_4": "A/B testiranje",
  "agency_pricing_p_5": "Prioritetna podrška",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Rastuća poduzeća",
  "agency_pricing_pr_1": "Sve iz Performance paketa",
  "agency_pricing_pr_2": "Upravljanje Google oglasima",
  "agency_pricing_pr_3": "Tjedne revizije performansi",
  "agency_pricing_pr_4": "Posvećeni upravitelj računa",
  "agency_pricing_pr_5": "Prilagođene integracije",
  "agency_social_title": "Povjerenje lokalnih tvrtki",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Analiziram ponašanje posjetitelja u stvarnom vremenu kako bih poboljšao vaše konverzije.",
  "agency_social_see_clients": "Što kažu naši klijenti",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "Direktor, Lokalna trgovina",
  "agency_social_t1_text": "Udvostručili smo leadove u prvom mjesecu! Web stranica se učitava trenutno i naši kupci obožavaju novi dizajn.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Vlasnica restorana",
  "agency_social_t2_text": "Naše online narudžbe porasle su za 40% nakon pokretanja nove stranice. Razlika u brzini je nebo i zemlja.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Fitness studio",
  "agency_social_t3_text": "Profesionalno, brzo i stvarno ispunjavaju obećanja. Naša stopa rezervacija porasla je za 35% u samo 3 tjedna.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Vlasnica butika",
  "agency_social_t4_text": "Postavljanje e-trgovine bilo je besprijekorno. Samo oporavak košarice isplatio je Performance plan u prvom kvartalu.",
  "agency_social_metric_1": "Prosj. vrijeme učitavanja",
  "agency_social_metric_2": "Više leadova",
  "agency_social_metric_3": "Zadovoljstvo klijenata",
  "agency_services_title": "Sve što vaše poslovanje treba",
  "agency_services_subtitle": "Sveobuhvatna digitalna rješenja za rast vaše online prisutnosti.",
  "agency_svc_fast_title": "Brze web stranice",
  "agency_svc_fast_desc": "Prilagođene stranice koje se učitavaju ispod 1 sekunde. Mobile-first, SEO optimizirane, fokusirane na konverziju.",
  "agency_svc_ecom_title": "E-Commerce trgovine",
  "agency_svc_ecom_desc": "Prodajte online s oporavkom košarice, obradom plaćanja i upravljanjem zalihama.",
  "agency_svc_seo_title": "SEO revizija i optimizacija",
  "agency_svc_seo_desc": "Rangirajte se više na Googleu. Tehnički SEO, strategija sadržaja i mjesečni izvještaji.",
  "agency_svc_ads_title": "Postavljanje Google oglasa",
  "agency_svc_ads_desc": "Brzo dobijte ciljani promet. Postavljanje kampanje, optimizacija i praćenje ROI-ja uključeno.",
  "agency_svc_maint_title": "Održavanje i podrška",
  "agency_svc_maint_desc": "Hosting, sigurnosna ažuriranja, sigurnosne kopije i promjene sadržaja. Od €30/mjesec.",
  "agency_faq_title": "Često postavljana pitanja",
  "agency_faq_q1": "Koliko brzo će se moja web stranica učitavati?",
  "agency_faq_a1": "Ispod 1 sekunde. Optimiziramo svaku milisekundu — od odgovora servera do potpunog vizualnog prikaza.",
  "agency_faq_q2": "Što je uključeno u Starter paket od €498?",
  "agency_faq_a2": "Munjevito brza prilagođena web stranica, domena i hosting za 1 godinu, osnovna analitička ploča, mobilno prilagođeni dizajn i SSL certifikat.",
  "agency_faq_q3": "Koliko vremena treba do pokretanja?",
  "agency_faq_a3": "Većina Starter projekata pokreće se za 2-3 tjedna. Performance i Premium planovi obično traju 4-6 tjedana.",
  "agency_faq_q4": "Nudite li kontinuirano održavanje?",
  "agency_faq_a4": "Da. Nakon prve godine, održavanje počinje od €30/mjesec, uključujući hosting, sigurnosna ažuriranja, sigurnosne kopije i manje promjene sadržaja.",
  "agency_faq_q5": "Mogu li nadograditi svoj plan kasnije?",
  "agency_faq_a5": "Apsolutno. Možete nadograditi sa Starter na Performance ili Premium u bilo kojem trenutku. Uračunat ćemo vašu početnu investiciju.",
  "agency_cta_title_1": "Spremni za rast ",
  "agency_cta_title_2": "bez granica?",
  "agency_cta_subtitle": "Recite nam o svom poslovanju i kreirat ćemo prilagođeni plan za rast vaše online prisutnosti. Besplatna konzultacija, bez obveze.",
  "agency_contact_name": "Vaše ime",
  "agency_contact_email": "E-mail adresa",
  "agency_contact_biz_select": "Odaberite vrstu poslovanja",
  "agency_contact_biz_restaurant": "Restoran / Hrana",
  "agency_contact_biz_retail": "Maloprodaja / Trgovina",
  "agency_contact_biz_services": "Profesionalne usluge",
  "agency_contact_biz_fitness": "Fitness / Wellness",
  "agency_contact_biz_realestate": "Nekretnine",
  "agency_contact_biz_other": "Ostalo",
  "agency_contact_submit": "Zatražite besplatnu konzultaciju",
  "agency_contact_sent_title": "Poruka poslana!",
  "agency_contact_sent_desc": "Javit ćemo vam se unutar 24 sata.",
  "agency_exit_title": "Čekajte! Besplatna revizija brzine?",
  "agency_exit_desc": "Saznajte koliko bi vaša web stranica mogla biti brža. Dobijte detaljan izvještaj o performansama — 100% besplatno.",
  "agency_exit_email": "Vaš email",
  "agency_exit_submit": "Pošalji reviziju",
  "agency_exit_thanks_title": "Hvala!",
  "agency_exit_thanks_desc": "Poslat ćemo vam besplatnu reviziju brzine unutar 24 sata.",
  "agency_footer_brand_desc": "Razvijeno, hostirano i dizajnirano od Infinitybusiness.org",
  "agency_footer_services": "Usluge",
  "agency_footer_fast_web": "Brze web stranice",
  "agency_footer_ecom": "E-Commerce trgovine",
  "agency_footer_seo": "SEO revizija",
  "agency_footer_ads": "Postavljanje Google oglasa",
  "agency_footer_maint": "Održavanje",
  "agency_footer_company": "Tvrtka",
  "agency_footer_about": "O nama",
  "agency_footer_contact": "Kontakt",
  "agency_footer_privacy": "Pravila privatnosti",
  "agency_footer_terms": "Uvjeti korištenja",
  "agency_footer_touch": "Kontaktirajte nas",
  "agency_footer_copyright": "© 2026 Infinity Business. Sva prava pridržana.",
  "agency_footer_dev_by": "Razvijeno, hostirano i dizajnirano od",
  "agency_footer_newsletter": "Pretplatite se na newsletter",
  "agency_footer_subscribe": "Pretplatite se",
  "agency_sticky_pricing": "Pogledaj cijene",
  "showroom_page_title": "Izlog",
  "showroom_meta_desc": "Istražite naš portfolio transformacija web stranica. Usporedbe prije i poslije stvarnih klijentskih projekata.",
  "showroom_badge": "Naš Rad",
  "showroom_title_prefix": "Projektni",
  "showroom_title_highlight": "Izlog",
  "showroom_subtitle": "Pogledajte stvarne transformacije. Povucite klizač za usporedbu stanja prije i poslije naših klijentskih projekata.",
  "showroom_search_placeholder": "Pretražite projekte...",
  "showroom_all_services": "Sve Usluge",
  "showroom_sort_newest": "Najnovije prvo",
  "showroom_sort_oldest": "Najstarije prvo",
  "showroom_sort_name_az": "Naziv A-Z",
  "showroom_sort_name_za": "Naziv Z-A",
  "showroom_active_filters": "Aktivni filteri",
  "showroom_showing": "Prikazano",
  "showroom_project_singular": "projekt",
  "showroom_project_plural": "projekata",
  "showroom_empty": "Još nema projekata u izlogu.",
  "showroom_no_match": "Nijedan projekt ne odgovara vašim filterima.",
  "showroom_features_built": "Izrađene Funkcionalnosti",
  "showroom_visit_live": "Posjetite Stranicu"
};
